import zlib from 'zlib'
import { DateTime } from 'luxon'
import { aiAssistants, formatAverage, formatDuration, formatPercent, socialChannels } from '../../app/utils/common'
import { promisify } from 'util'
import { ga4HeaderAsArray } from '../../app/utils/Metrics'

const gunzip = promisify(zlib.gunzip)

let sumByLastIndex = (arr) => {
    let index = {}
    for (let i=0; i<arr.length; i++) {
        let row = arr[i], key = row[row.length-1]
        // TODO josh: row[-2] is the date of the row and shouldn't be calculated
        let data = row.slice(0, row.length-1).map(x=>+x)
        index[key] = index[key]||[]
        data.forEach((x, i)=>index[key][i] = (index[key][i]||0)+x)
    }
    return Object.keys(index).map(key => [key, index[key]])
}

let sumArrays = arr => {
    if (!arr.length)
        return arr
    let ans = arr[0].slice(0)
    for (let i=1; i<arr.length; i++) {
        arr[i].forEach((el, j) => ans[j] += el)
    }
    return ans
}

export default async function(dateRangeMetrics, key, site, dataMonthlyMetrics){
    console.time("processResponse")
    // TODO josh: trafReport -> dateRangeMetrics all over
    let trafReport = [...dateRangeMetrics]

    let perf = {key: key}
    let mediumMetrics = []
    let mobileMediumMetrics = []
    let sourceMediumMetrics = []
    let emailSrcMedMetrics = []
    let emailDeviceMetrics = []
    let deviceCategoryMetrics = []
    let dcMetricsAdd = []
    let brMetrics = []
    let ldMetrics = []
    let mobileSourceMediumMetrics = []
    let emailMobSrcMedMetrics = []

    let sourceMediumMetricsNonCpc = []
    let mobileSourceMediumMetricsNonCpc = []

    let userTypeMetrics = []
    let uaUserTypeMetrics = []
    let goalMetrics = []
    let goals = {}
    let evMetrics = []
    let adMetrics = []
    let adMetricsByDay = []
    let gaAdMetricsByDay = []
    let otherAdMetrics = []
    let otherAdDeviceMetrics = []

    let adMetricsUnfettered = []

    let gmbAdMetrics = []
    
    let aiAdMetrics = []

    let adMetricsByDevice = []
    let mobileOtherAdMetrics = []
    let fbMetrics = []
    let fbPixelMetrics = []
    let fbFormLeadMetrics = []
    
    let fbFanMetrics = []
    let igMetrics = []
    let gmbMetrics = []
    let gbpMetrics = []
    let cityMetrics = []

    let gaEcomMetrics = []
    let gaEcomDeviceCategoryMetrics = []
    let gaEcomCampaignMetrics = []
    let gaEcomSrcMedMetrics = []

    let gaEcomProductMetrics = []
    
    let bingMetrics = []
    let bingMetricsByDeviceType = []
    let bingCampaignMetrics = []

    let linkedinMetrics = []
    let linkedinOrgMetrics = []

    let sourceToCampaignMap = {}
    let sourceMedToCampaignMap = {}

    let socialReviewMetrics = []
    let socialReviewTotalsByChannel = {}
    let socialReviewSummary = {
        positive: {
            count: 0,
            percent: 0
        },
        neutral: {
            count: 0,
            percent: 0
        },
        negative: {
            count: 0,
            percent: 0
        },
        total: 0,
        ratingTotal: 0,
        avgRating: 0
    }

    let leadsBySrcMedHour = []

    let gscMetrics = []
    let gscMetricsByPage = []
    let gscMetricsByQuery = []
    let gscMetricsByDevice = []

    perf.dataMonthlyMetrics = {}

    if(dataMonthlyMetrics){
        perf.dataMonthlyMetrics = dataMonthlyMetrics
    }

    let date_times = {}
    let hasGa4 = false
    let hasUA = false

    for(let idx=0; idx < trafReport.length; idx ++) {
        let dayMetrics = {...trafReport[idx]}
        let date = dayMetrics.date
        let ts = DateTime.fromISO(date)

        date_times[date] = ts.toMillis()

        let ga_reports = []
        let hasBuffer = false
        if(dayMetrics.ga && dayMetrics.ga.type === "Buffer"){
            hasBuffer = true
            let gaBinary = await gunzip(Buffer.from(dayMetrics.ga.data))

            let gaConv = JSON.parse(gaBinary)

            if(gaConv === null || gaConv.reports === null || gaConv.reports[0].data === undefined){
                if(!gaConv?.reports || !gaConv?.reports[0].rows){
                    ga_reports = []
                }
            }
            ga_reports = gaConv?.reports ?? []

            dayMetrics = {
                ...dayMetrics,
                ga: gaConv
            }


        } else {
            if(dayMetrics.ga === null || 
                dayMetrics.ga === undefined || 
                dayMetrics.ga.reports === null || 
                dayMetrics.ga.reports === undefined || dayMetrics.ga.reports[0].data === undefined){
                if(!dayMetrics?.ga?.reports || !dayMetrics?.ga?.reports[0].rows){
                    ga_reports = []
                }
            }

            ga_reports = dayMetrics?.ga?.reports ?? []
        }

        if(dayMetrics.fb && dayMetrics.fb.type === "Buffer"){
            hasBuffer = true
            let fbBinary = await gunzip(Buffer.from(dayMetrics.fb.data))

            let fbConv = JSON.parse(fbBinary)

            dayMetrics.fb = fbConv
        }
        if(dayMetrics.fbPage && dayMetrics.fbPage.type === "Buffer"){
            hasBuffer = true
            let fbPageBinary = await gunzip(Buffer.from(dayMetrics.fbPage.data))

            let fbPageConv = JSON.parse(fbPageBinary)

            dayMetrics.fbPage = fbPageConv
        }
        if(dayMetrics.gmb && dayMetrics.gmb.type === "Buffer"){
            hasBuffer = true
            let gmbBinary = await gunzip(Buffer.from(dayMetrics.gmb.data))

            let gmbConv = JSON.parse(gmbBinary)

            dayMetrics.gmb = gmbConv
        }
        if(dayMetrics.linkedin && dayMetrics.linkedin.type === "Buffer"){
            hasBuffer = true
            let linkedinBinary = await gunzip(Buffer.from(dayMetrics.linkedin.data))

            let linkedinConv = JSON.parse(linkedinBinary)

            dayMetrics.linkedin = linkedinConv
        }
        if(dayMetrics.linkedinOrg && dayMetrics.linkedinOrg.type === "Buffer"){
            hasBuffer = true
            let linkedinOrgBinary = await gunzip(Buffer.from(dayMetrics.linkedinOrg.data))

            let linkedinOrgConv = JSON.parse(linkedinOrgBinary)

            dayMetrics.linkedinOrg = linkedinOrgConv
        }
        if(dayMetrics.linkedinOrgLt && dayMetrics.linkedinOrgLt.type === "Buffer"){
            hasBuffer = true
            let linkedinOrgLtBinary = await gunzip(Buffer.from(dayMetrics.linkedinOrgLt.data))

            let linkedinOrgLtConv = JSON.parse(linkedinOrgLtBinary)

            dayMetrics.linkedinOrgLt = linkedinOrgLtConv
        }
        if(dayMetrics.bing && dayMetrics.bing.type === "Buffer"){
            hasBuffer = true
            let bingBinary = await gunzip(Buffer.from(dayMetrics.bing.data))

            let bingConv = JSON.parse(bingBinary)

            dayMetrics.bing = bingConv
        }
        if(dayMetrics.gsc && dayMetrics.gsc.type === "Buffer"){
            hasBuffer = true
            let gscBinary = await gunzip(Buffer.from(dayMetrics.gsc.data))

            let gscConv = JSON.parse(gscBinary)

            dayMetrics.gsc = gscConv
        }


        if(hasBuffer){
            trafReport[idx] = {...dayMetrics}
        }

        if (ga_reports[0] && ga_reports[0].data && ga_reports[0].data.rows) {
            hasUA = true
            ga_reports[0].data.rows.forEach(row => {
                mediumMetrics.push([...row.metrics[0].values, date, row.dimensions[0]])
                sourceMediumMetrics.push([...row.metrics[0].values, date, row.dimensions[1]])
                if(!row.dimensions[0].includes("cpc")){
                    sourceMediumMetricsNonCpc.push([...row.metrics[0].values, date, row.dimensions[1]])
                }
                if (row.dimensions[2] === 'mobile') {
                    mobileMediumMetrics.push([...row.metrics[0].values, date, row.dimensions[0]])
                    mobileSourceMediumMetrics.push([...row.metrics[0].values, date, row.dimensions[1]])

                    if(!row.dimensions[0].includes("cpc")){
                        mobileSourceMediumMetricsNonCpc.push([...row.metrics[0].values, date, row.dimensions[1]])
                    }
                }
                deviceCategoryMetrics.push([...row.metrics[0].values, date, row.dimensions[2]])
                userTypeMetrics.push([...row.metrics[0].values, date, row.dimensions[3]])
                uaUserTypeMetrics.push([...row.metrics[0].values, date, row.dimensions[3]])
                goalMetrics.push([row.metrics[0].values[2], date])
            })
        } else if(ga_reports[0] && ga_reports[0].rows){
            hasGa4 = true
            ga_reports[0].rows.forEach(row => {
                let m = ga4HeaderAsArray([...row.metricValues])

                mediumMetrics.push([...m, date, row.dimensionValues[0].value])
                sourceMediumMetrics.push([...m, date, row.dimensionValues[1].value])
                if(!row.dimensionValues[0].value.includes("cpc")){
                    sourceMediumMetricsNonCpc.push([...m, date, row.dimensionValues[1].value])
                }
                if (row.dimensionValues[2].value === 'mobile') {
                    mobileMediumMetrics.push([...m, date, row.dimensionValues[0].value])
                    mobileSourceMediumMetrics.push([...m, date, row.dimensionValues[1].value])

                    if(!row.dimensionValues[0].value.includes("cpc")){
                        mobileSourceMediumMetricsNonCpc.push([...m, date, row.dimensionValues[1].value])
                    }
                }
                deviceCategoryMetrics.push([...m, date, row.dimensionValues[2].value])
                userTypeMetrics.push([...m, date, row.dimensionValues[3].value])
                goalMetrics.push([row.metricValues[2].value, date])
            })
        }

        if (ga_reports[1] && ga_reports[1].data && ga_reports[1].data.rows) {
            ga_reports[1].data.rows.forEach(row => {
                dcMetricsAdd.push([...row.metrics[0].values, date, row.dimensions[0]])
                brMetrics.push([...row.metrics[0].values, date, row.dimensions[1]])
                ldMetrics.push([...row.metrics[0].values, date])
            })
        } else if(ga_reports[1] && ga_reports[1].rows){
            ga_reports[1].rows.forEach(row => {
                let m = ga4HeaderAsArray(row.metricValues)

                dcMetricsAdd.push([...m, date, row.dimensionValues[0].value])
                brMetrics.push([...m, date, row.dimensionValues[1].value])
                ldMetrics.push([...m, date])
            })
        }

        if (ga_reports[2] && ga_reports[2].data && ga_reports[2].data.rows) {
            ga_reports[2].data.rows.forEach(row => {
                row.metrics[0].values.forEach((value, idx) => {
                    if (+value === 0) {
                        return
                    }
                    let gname = `goal${idx+1}`
                    goals[gname] = goals[gname]||[]
                    goals[gname].push([...row.dimensions, value, date_times[date]])
                })
            })
        } else if(ga_reports[2] && ga_reports[2].rows){
            // These pulls are not being utilized at all whatsoever for GA4
            // It basically acts as a filler to satisfy how the pull is performed for UA
        }


        if (ga_reports[3] && ga_reports[3].data && ga_reports[3].data.rows) {
            ga_reports[3].data.rows.forEach(row => {
                row.metrics[0].values.forEach((value, idx) => {
                    if (+value === 0) {
                        return
                    }
                    let gname = `goal${idx+11}`
                    goals[gname] = goals[gname]||[]
                    goals[gname].push([...row.dimensions, value, date_times[date]])
                })
            })
        } else if(ga_reports[3] && ga_reports[3].rows){
            // These pulls are not being utilized at all whatsoever for GA4
            // It basically acts as a filler to satisfy how the pull is performed for UA            
        }

        if (ga_reports[4] && ga_reports[4].data && ga_reports[4].data.rows) {
            ga_reports[4].data.rows.forEach(row => {
                evMetrics.push([...row.metrics[0].values, date, {hasUA: true}, null, row.dimensions[1], row.dimensions[3], row.dimensions[0]])
            })
        } else if(ga_reports[4] && ga_reports[4].rows){
            ga_reports[4].rows.forEach(row => {
                let m = ga4HeaderAsArray(row.metricValues)
                evMetrics.push([...m, date, {hasGA4: true}, row.dimensionValues[2].value, row.dimensionValues[1].value, row.dimensionValues[3].value, row.dimensionValues[0].value])
            })
        }

        if (ga_reports[5] && ga_reports[5].data && ga_reports[5].data.rows) {
            ga_reports[5].data.rows.forEach(row => {
                if (row.dimensions[0] !== '(not set)') {
                    if(row.metrics[0].values && (+row.metrics[0].values[3] > 0 || +row.metrics[0].values[5] > 0)){
                        adMetrics.push([...row.metrics[0].values, date, row.dimensions[1], row.dimensions[0]])
                    }

                    adMetricsByDay.push([row.metrics[0].values[3], date])
                    gaAdMetricsByDay.push([row.metrics[0].values[3], date])
                }
            })
        } else if(ga_reports[5] && ga_reports[5].rows){
            ga_reports[5].rows.forEach(row => {
                if (row.dimensionValues[0].value !== '(not set)' &&
                    row.dimensionValues[0].value !== '') {
                    let m = ga4HeaderAsArray([...row.metricValues])
                    if(m && (+m[3] > 0 || +m[5] > 0)){
                        adMetrics.push([...m, date, row.dimensionValues[1].value, row.dimensionValues[0].value])
                    }

                    adMetricsByDay.push([m[3], date])
                    gaAdMetricsByDay.push([m[3], date])
                }
            })
        }

        if (ga_reports[6] && ga_reports[6].data && ga_reports[6].data.rows) {
            ga_reports[6].data.rows.forEach(row => {
                if (row.dimensions[0] !== '(not set)') {
                            
                    if (row.dimensions[0].toLowerCase().includes("email") || 
                        row.dimensions[2].toLowerCase().includes('email')){
                        emailSrcMedMetrics.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[0]])
                        emailDeviceMetrics.push([...row.metrics[0].values, date, row.dimensions[1]])
                        
                        if (row.dimensions[1] === 'mobile') {
                            emailMobSrcMedMetrics.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[0]])
                        }
                    } else {
                        const channels = [...Object.values(socialChannels).map(s => s[0])]

                        const hasSocial = channels.reduce((prev, curr) => {
                            if(row.dimensions[2].toLowerCase().includes(curr)){
                                prev = true
                            }

                            return prev
                            
                        }, false)

                        if(!row.dimensions[2].includes("cpc") &&
                            !hasSocial &&
                            row.dimensions[2].toLowerCase() != 'psocial' &&
                            row.dimensions[3].toLowerCase().indexOf("bing") == -1 &&
                            row.dimensions[3].toLowerCase() !== "google-my-place") {
                            if(row.dimensions[1] == 'mobile'){
                                mobileOtherAdMetrics.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[0]])
                            }

                            otherAdMetrics.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[0]])
                            otherAdDeviceMetrics.push([...row.metrics[0].values, date, row.dimensions[2], row.dimensions[1]])
                        }
                        
                        if(row.dimensions[3].toLowerCase() === "google-my-place") {
                            gmbAdMetrics.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[0]])                            
                        } 
                    }

                    sourceToCampaignMap[row.dimensions[0]] = row.dimensions[3]
                    sourceMedToCampaignMap[row.dimensions[0]] = row.dimensions[2]
                }

                adMetricsUnfettered.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[0]])
            })
        } else if(ga_reports[6] && ga_reports[6].rows){
            ga_reports[6].rows.forEach(row => {
                let m = ga4HeaderAsArray(row.metricValues)

                if (row.dimensionValues[0].value !== '(not set)' &&
                    row.dimensionValues[0].value !== '') {
                            
                    if (row.dimensionValues[0].value.toLowerCase().includes("email") || 
                        row.dimensionValues[2].value.toLowerCase().includes('email')){
                        emailSrcMedMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[0].value])
                        emailDeviceMetrics.push([...m, date, row.dimensionValues[1].value])
                        
                        if (row.dimensionValues[1].value === 'mobile') {
                            emailMobSrcMedMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[0].value])
                        }
                    } else {
                        const channels = [...Object.values(socialChannels).map(s => s[0])]

                        const hasSocial = channels.reduce((prev, curr) => {
                            if(row.dimensionValues[2].value.toLowerCase().includes(curr)){
                                prev = true
                            }

                            return prev

                        }, false)
                        
                        if(!row.dimensionValues[2].value.includes("cpc") &&
                            !hasSocial && 
                            !row.dimensionValues[2].value.includes("ai-assistant") &&
                            !aiAssistants.includes(row.dimensionValues[3].value) &&
                            row.dimensionValues[2].value.toLowerCase() != 'psocial' &&
                            row.dimensionValues[3].value.toLowerCase().indexOf("bing") == -1 &&
                            !row.dimensionValues[3].value.toLowerCase().includes("google-my-place") && 
                            !row.dimensionValues[0].value.toLowerCase().includes("(organic)") && 
                            !row.dimensionValues[2].value.toLowerCase().includes("(organic)")) {
                            if(row.dimensionValues[1].value == 'mobile'){
                                mobileOtherAdMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[0].value])
                            }

                            otherAdMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[0].value])
                            otherAdDeviceMetrics.push([...m, date, row.dimensionValues[2].value, row.dimensionValues[1].value])
                        }
                        
                        if(row.dimensionValues[3].value.toLowerCase() === "google-my-place") {
                            gmbAdMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[0].value])                            
                        }

                        // if(!row.dimensionValues[2].value.includes("ai-assistant") &&
                        //     !aiAssistants.includes(row.dimensionValues[3].value)){
                        //     aiAdMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[0].value])
                        // }
                    }

                    sourceToCampaignMap[row.dimensionValues[0].value] = row.dimensionValues[3].value
                    sourceMedToCampaignMap[row.dimensionValues[0].value] = row.dimensionValues[2].value
                }

                adMetricsUnfettered.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[0].value])
            })
        }


        if (ga_reports[7] && ga_reports[7].data && ga_reports[7].data.rows) {
            ga_reports[7].data.rows.forEach(row => {
                leadsBySrcMedHour.push([...row.metrics[0].values, date, ...row.dimensions])
            })
        } else if(ga_reports[7] && ga_reports[7].rows){
            ga_reports[7].rows.forEach(row => {
                let m = ga4HeaderAsArray(row.metricValues)
                let d = ga4HeaderAsArray(row.dimensionValues)
                leadsBySrcMedHour.push([...m, date, ...d])
            })
        }


        if (ga_reports[8] && ga_reports[8].data && ga_reports[8].data.rows) {
            ga_reports[8].data.rows.forEach(row => {
                cityMetrics.push([...row.metrics[0].values, date, ...row.dimensions])
            })
        } else if(ga_reports[8] && ga_reports[8].rows){
            ga_reports[8].rows.forEach(row => {
                let m = ga4HeaderAsArray(row.metricValues)
                let d = ga4HeaderAsArray(row.dimensionValues)

                cityMetrics.push([...m, date, ...d])
            })
        }

        if (ga_reports[9] && ga_reports[9].data && ga_reports[9].data.rows) {
            ga_reports[9].data.rows.forEach(row => {
                gaEcomMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date])
                gaEcomDeviceCategoryMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date, row.dimensions ? row.dimensions[0] : ""])
                gaEcomSrcMedMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date, row.dimensions ? row.dimensions[2] : ""])
                
                if (row.dimensions && row.dimensions[1] && row.dimensions[1] !== '(not set)' && row.dimensions[2] && row.dimensions[2].indexOf("cpc") !== -1){
                    gaEcomCampaignMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date, row.dimensions ? row.dimensions[1] : ""])
                }
            })
        }

        if (ga_reports[10] && ga_reports[10].data && ga_reports[10].data.rows) {
            ga_reports[10].data.rows.forEach(row => {
                gaEcomProductMetrics.push([...row.metrics[0].values, date, row.dimensions[0], row.dimensions[1]])
            })
        }

        if (dayMetrics.fb && dayMetrics.fb.reports[0]) {
            dayMetrics.fb.reports[0].data.rows?.forEach(row =>  fbMetrics.push([row, date]))
        }

        if (dayMetrics.fb && dayMetrics.fb.reports[2]) {
            dayMetrics.fb.reports[2].data.rows?.forEach(row => fbFormLeadMetrics.push([row, date]))
        }

        if (dayMetrics.fbPage && dayMetrics.fbPage.reports[0]) {
            dayMetrics.fbPage.reports[0].data?.rows?.forEach(row => fbFanMetrics.push([row, date]))
        }

        if (dayMetrics.igFollowers && dayMetrics.igFollowers.reports[0]) {
            dayMetrics.igFollowers.reports[0].data?.rows?.forEach(row => igMetrics.push([row, date]))
        }

        // if (dayMetrics.fb && dayMetrics.fb.reports[1]) {
        //     dayMetrics.fb.reports[1].data.rows.forEach(row =>  fbPixelMetrics.push([row, date]))
        // }


        if(dayMetrics?.gmb?.metricValues?.length > 0) {
            gmbMetrics.push({metricValues: dayMetrics.gmb.metricValues, date})
        } else if(dayMetrics.gmb){
            gbpMetrics.push([dayMetrics.gmb, date])
        }

        if(dayMetrics.bing && dayMetrics.bing.reports){
            if(dayMetrics.bing.reports[0]){
                dayMetrics.bing.reports[0].data.rows?.forEach(row => {
                    bingMetrics.push([row, date])
                    bingMetricsByDeviceType.push([...row.values[0], date, row.values[0][9]])
                })
            }
            if(dayMetrics.bing.reports[1]){
                dayMetrics.bing.reports[1].data.rows?.forEach(row => bingCampaignMetrics.push([...row.values[0], date, row.values[0][1], row.values[0][0]]))
            }
        }

        if(dayMetrics.linkedin && dayMetrics.linkedin.reports){
            if(dayMetrics.linkedin.reports[0]){
                dayMetrics.linkedin.reports[0].data.rows.forEach(row => {
                    linkedinMetrics.push([row, date])
                    // linkedinCampaignMetrics.push([...row, date, row.campaign.objectiveType, row.campaign.name, row.pivotValue ])   
                })
            }
        }

        if(dayMetrics.linkedinOrg){
            linkedinOrgMetrics.push([dayMetrics.linkedinOrg, date])
        }

        if(dayMetrics.gsc && dayMetrics.gsc.reports){
            if(dayMetrics?.gsc?.reports[0]){
                dayMetrics.gsc?.reports[0].data?.rows?.forEach(row => {
                    gscMetricsByPage.push([row.clicks, row.impressions, row.position, 1, date, row.keys[1]])
                })
            }
            if(dayMetrics?.gsc?.reports[1]){
                dayMetrics.gsc?.reports[1].data?.rows?.forEach(row => {
                    gscMetricsByQuery.push([row.clicks, row.impressions, row.position, 1, date, row.keys[1]])
                })
            }
            if(dayMetrics?.gsc?.reports[2]){
                dayMetrics.gsc?.reports[2].data?.rows?.forEach(row => {
                    gscMetrics.push([row.clicks, row.impressions, row.position, 1, date])
                })
            }
        }

        if(dayMetrics.social && dayMetrics.social.reviews){

            let metrics = dayMetrics.social.reviews.reduce((map, review, index, arr) => {
                if(map[review.review_site] == undefined){
                    map[review.review_site] = {
                        ratingTotal: 0,
                        count: 0
                    }
                }
                map[review.review_site].ratingTotal += review.rating
                map[review.review_site].count += 1

                if(review.rating == 3){
                    socialReviewSummary.neutral.count += 1
                }
                else if(review.rating < 3){
                    socialReviewSummary.negative.count += 1
                }
                else if(review.rating > 3){
                    socialReviewSummary.positive.count += 1
                }

                socialReviewSummary.total += 1
                socialReviewSummary.ratingTotal += review.rating
                
                return map
            }, {})

            Object.keys(metrics).forEach(key => {

                if(socialReviewTotalsByChannel[key] == undefined){
                    socialReviewTotalsByChannel[key] = {
                        count: 0,
                        ratingTotal: 0
                    }
                }

                socialReviewTotalsByChannel[key].count += metrics[key].count
                socialReviewTotalsByChannel[key].ratingTotal += metrics[key].ratingTotal

            })


            socialReviewMetrics.push({
                date,
                reviews: dayMetrics.social.reviews,
                total: dayMetrics.social.reviews.length,
                avgRating: dayMetrics.social.reviews.reduce((rating, review, index, arr) => {
                    rating += review.rating
                    return rating
                }, 0) / dayMetrics.social.reviews.length,
                metrics
            })
        }
        else{
            socialReviewMetrics.push({
                date,
                reviews: [],
                total: 0,
                avgRating:0,
                metrics: []
            })
        }
    }

    let combinedCityMetrics = cityMetrics.reduce((prev, curr, idx, arr) => {
        if(prev.all[curr[5]] === undefined){
            prev.all[curr[5]] = {}
        }

        if(prev.all[curr[5]][curr[6]] === undefined){
            prev.all[curr[5]][curr[6]] = {
                city: curr[5],
                region: curr[6],
                sessions: 0,
                goals: 0,
                transactions: 0,
                revenue: 0
            }
        }

        prev.all[curr[5]][curr[6]].sessions += parseInt(curr[0])
        prev.all[curr[5]][curr[6]].goals += parseInt(curr[1])
        prev.all[curr[5]][curr[6]].transactions += (curr[2] ? parseInt(curr[2]) : 0)
        prev.all[curr[5]][curr[6]].revenue += (curr[3] ? parseFloat(curr[3]) : 0)
        
        if(idx === arr.length -1){
            Object.keys(prev.all).forEach(k => {
                prev.all[k] = Object.values(prev.all[k])
            })

            prev.all = Object.values(prev.all)
        }

        if(curr[8] && curr[8] !== "(not set)"){
            if(prev.googlePaidAds[curr[5]] === undefined){
                prev.googlePaidAds[curr[5]] = {}
            }

            if(prev.googlePaidAds[curr[5]][curr[6]] === undefined){
                prev.googlePaidAds[curr[5]][curr[6]] = {
                    city: curr[5],
                    region: curr[6],
                    sessions: 0,
                    goals: 0,
                    transactions: 0,
                    revenue: 0
                }
            }

            prev.googlePaidAds[curr[5]][curr[6]].sessions += parseInt(curr[0])
            prev.googlePaidAds[curr[5]][curr[6]].goals += parseInt(curr[1])
            prev.googlePaidAds[curr[5]][curr[6]].transactions += (curr[2] ? parseInt(curr[2]) : 0)
            prev.googlePaidAds[curr[5]][curr[6]].revenue += (curr[3] ? parseFloat(curr[3]) : 0)
            
        }

        if(idx === arr.length -1){
            Object.keys(prev.googlePaidAds).forEach(k => {
                prev.googlePaidAds[k] = Object.values(prev.googlePaidAds[k])
            })

            prev.googlePaidAds = Object.values(prev.googlePaidAds)
        }

        return prev
    }, {
        all: {},
        googlePaidAds: {}
    })

    if(!Array.isArray(combinedCityMetrics.all) && Object.keys(combinedCityMetrics.all).length === 0){
        combinedCityMetrics.all = []
    }

    if(!Array.isArray(combinedCityMetrics.googlePaidAds) && Object.keys(combinedCityMetrics.googlePaidAds).length === 0){
        combinedCityMetrics.googlePaidAds = []
    }

    perf.hasGa4 = hasGa4
    perf.hasUA = hasUA

    perf.gscMetricsByDay = sumByLastIndex(gscMetrics)
    perf.gscMetricsByPage = sumByLastIndex(gscMetricsByPage)
    perf.gscMetricsByQuery = sumByLastIndex(gscMetricsByQuery)
    // perf.gscMetricsByDevice = sumByLastIndex(gscMetricsByDevice)

    perf.gscMetricTotals = sumArrays(perf.gscMetricsByDay.map(el => el[1]))

    perf.cityMetrics = []
    perf.cityMetricsFromGoogleAds = []
    perf.gaEcomMetrics = gaEcomMetrics

    perf.gaEcomRevenue = 0
    perf.gaEcomAvgOrderVal = 0
    perf.gaEcomTransactions = 0
    perf.gaEcomSessions = 0
    perf.gaEcomGCR = 0
    perf.gaEcomROAS = 0
    perf.gaEcomAdSpend = 0
    perf.gaEcomRevenueWSpend = 0

    perf.gaEcomMetricsByDay = sumByLastIndex(gaEcomMetrics)
    perf.gaEcomMetricsByProduct = sumByLastIndex(gaEcomProductMetrics)


    perf.gaEcomRevenueByProduct = 0
    perf.gaEcomMetricsByProduct.forEach(prod => {
        perf.gaEcomRevenueByProduct += parseFloat(prod[1][0])
    })

    perf.gaEcomMetricsDetails = perf.gaEcomMetricsByDay.reduce((prev, curr, idx, arr) => {
        let dt = date_times[curr[0]]

        prev[0].values.push([dt, parseFloat(curr[1][4]).toFixed(2)])
        prev[1].values.push([dt, (parseInt(curr[1][1]) / parseInt(curr[1][0]) * 100).toFixed(2)])

        perf.gaEcomSessions += parseInt(curr[1][0])
        perf.gaEcomTransactions += parseInt(curr[1][1])
        perf.gaEcomRevenue += parseFloat(curr[1][4])
        perf.gaEcomAdSpend += parseFloat(curr[1][6])

        if(parseFloat(curr[1][6]) > 0){
            perf.gaEcomRevenueWSpend += parseFloat(curr[1][4])
        }

        if(parseFloat(curr[1][4]) > parseFloat(prev[0]._highestValue)){
            prev[0]._highestValue = parseFloat(curr[1][4])
        }

        if((parseInt(curr[1][1]) / parseInt(curr[1][0]) * 100) > parseFloat(prev[1]._highestValue)){
            prev[1]._highestValue = (parseInt(curr[1][1]) / parseInt(curr[1][0]) * 100)
        }

        if(idx === (arr.length - 1)){
            perf.gaEcomGCR = parseFloat((perf.gaEcomTransactions / perf.gaEcomSessions).toFixed(2))
            perf.gaEcomROAS = parseFloat((perf.gaEcomRevenueWSpend / perf.gaEcomAdSpend).toFixed(2))
        }
        
        return prev
    }, [
        { key: "Revenue", values: [], yAxis: 1, _highestValue: 0},
        { key: "Ecommerce Conversion Rate", values: [], yAxis: 2, _highestValue: 0}
    ])
    perf.gaEcomAvgOrderVal = parseFloat((perf.gaEcomRevenue / perf.gaEcomTransactions).toFixed(2))
    
    perf.gaEcomMetricsByCategory = sumByLastIndex(gaEcomDeviceCategoryMetrics)

    perf.gaEcomMetricsByCategoryDetails = perf.gaEcomMetricsByCategory.map(src => ({
        id: src[0],
        ecr: src[1][1] / src[1][0],
        transactions: src[1][1],
        revenue: src[1][3]
    }))

    perf.gaEcomSrcMedMetrics = sumByLastIndex(gaEcomSrcMedMetrics)
    perf.gaEcomCampaignMetrics = sumByLastIndex(gaEcomCampaignMetrics)

    combinedCityMetrics?.all?.forEach(region => {
        region.forEach(city => {
            perf.cityMetrics.push(city)
        })
    })

    combinedCityMetrics?.googlePaidAds?.forEach(region => {
        region.forEach(city => {
            perf.cityMetricsFromGoogleAds.push(city)
        })
    })

    // perf.cityMetrics = perf.cityMetrics.sort((a, b) => b.sessions-a.sessions).slice(0, 10)

    // perf.fbPixelMetrics = fbPixelMetrics
    perf.fbFanMetrics = fbFanMetrics
    perf.bingMetrics = bingMetrics

    perf.mediumMetrics = mediumMetrics
    perf.bingGoals = 0
    perf.bingImpressions = 0
    perf.bingAdSpend = 0
    perf.bingClicks = 0
    perf.bingRevenue = 0

    let totalBingClicks = 0

    let fbFanMetricsByDay = {}
    let igMetricsByDay = {}
    let bingCampaignDayMetrics = {}
    let bingMetricsByDay = {}

    bingMetrics.forEach(m => {
        if(bingMetricsByDay[m[1]] === undefined){
            bingMetricsByDay[m[1]] = {
                goals: 0,
                impressions: 0,
                spend: 0
            }
        }

        bingMetricsByDay[m[1]].goals += parseInt(m[0].values[0][6])
        bingMetricsByDay[m[1]].impressions += parseInt(m[0].values[0][2])
        bingMetricsByDay[m[1]].spend += m[0].values?.length > 0 ? parseFloat(m[0].values[0][4]) : 0

        perf.bingGoals += parseInt(m[0].values[0][6])
        perf.bingImpressions += parseInt(m[0].values[0][2])
        perf.bingAdSpend += m[0].values?.length > 0 ? parseFloat(m[0].values[0][4]) : 0
        
        totalBingClicks += parseFloat(m[0].values[0][3])  
        perf.bingRevenue += parseFloat(m[0].values[0][11])  
        
        adMetricsByDay.push([parseFloat(m[0].values[0][4]), m[1]])
    })

    perf.bingMetricsByDay = bingMetricsByDay
    perf.linkedInAdSpend = 0
    perf.linkedInLeadAdSpend = 0
    perf.linkedInClicks = 0
    perf.linkedInImpressions = 0
    perf.linkedInGoals = 0
    perf.linkedInLeads = 0

    perf.linkedInGoalsByDay = {}
    perf.linkedInLeadsByDay = {}
    perf.linkedInCampaigns = {}
    perf.linkedInSpendByDay = {}

    const linkedInLeadTypes = ['LEAD_GENERATION', 'WEBSITE_CONVERSION']

    linkedinMetrics.forEach(m => {
        perf.linkedInAdSpend += m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0
        perf.linkedInClicks += m[0].clicks ?? 0
        perf.linkedInImpressions += m[0].impressions
        perf.linkedInGoals += m[0].externalWebsiteConversions ?? 0

        adMetricsByDay.push([m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0, m[1]])

        if(perf.linkedInGoalsByDay[m[1]] === undefined){
            perf.linkedInGoalsByDay[m[1]] = 0
        }
        if(perf.linkedInLeadsByDay[m[1]] === undefined){
            perf.linkedInLeadsByDay[m[1]] = 0
        }
        if(perf.linkedInSpendByDay[m[1]] === undefined){
            perf.linkedInSpendByDay[m[1]] = 0
        }

        perf.linkedInGoalsByDay[m[1]] += m[0].externalWebsiteConversions ?? 0
        perf.linkedInSpendByDay[m[1]] += m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0

        if(perf.linkedInCampaigns[m[0].pivotValue] === undefined){
            perf.linkedInCampaigns[m[0].pivotValue] = {
                campaign: m[0].campaign,
                costInUsd: 0,
                leadsCostInUsd: 0,
                clicks: 0,
                impressions: 0,
                externalWebsiteConversions: 0,
                leads: 0,
                days: {}
            }
        }

        if(perf.linkedInCampaigns[m[0].pivotValue].days[m[1]] === undefined){
            perf.linkedInCampaigns[m[0].pivotValue].days[m[1]] = {
                clicks: 0
            }
        }

        perf.linkedInCampaigns[m[0].pivotValue].days[m[1]].clicks += m[0].clicks

        perf.linkedInCampaigns[m[0].pivotValue].costInUsd += m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0
        perf.linkedInCampaigns[m[0].pivotValue].clicks += m[0].clicks ?? 0
        perf.linkedInCampaigns[m[0].pivotValue].impressions += m[0].impressions
        perf.linkedInCampaigns[m[0].pivotValue].externalWebsiteConversions += m[0].externalWebsiteConversions ?? 0

        if(linkedInLeadTypes.includes(m[0].campaign.objectiveType)){
            perf.linkedInCampaigns[m[0].pivotValue].leads += m[0].externalWebsiteConversions ?? 0
            perf.linkedInCampaigns[m[0].pivotValue].leadsCostInUsd += m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0
            
            perf.linkedInLeads += m[0].externalWebsiteConversions ?? 0
            perf.linkedInLeadAdSpend += m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0

            perf.linkedInLeadsByDay[m[1]] += m[0].externalWebsiteConversions ?? 0
        }
    })

    perf.gmbAdMetricTotals = gmbAdMetrics.reduce((prev, curr) => {
        prev.goals += +curr[2]

        return prev
    }, {
        goals: 0
    })

    perf.linkedInCampaigns = Object.values(perf.linkedInCampaigns)

    perf.linkedInCampaignDetails = perf.linkedInCampaigns.map(m => ({
        key: m.campaign.name,
        values: Object.keys(date_times).map(key => ([
            date_times[key],
            m.days[key] ? m.days[key].clicks : 0
        ]))
    }))
    
    perf.linkedinOrgMetrics = linkedinOrgMetrics

    perf.linkedInOrgStats = linkedinOrgMetrics.reduce((prev, curr) => {
        prev.impressions += (curr[0].shareStats?.totalShareStatistics?.impressionCount ?? 0)
        prev.followers += (curr[0].followerStats?.followerGains?.organicFollowerGain ?? 0) + (curr[0].followerStats?.followerGains?.paidFollowerGain ?? 0)
    
        return prev
    }, {
        followers: 0,
        impressions: 0
    })
    bingCampaignMetrics.forEach(m => {
        if(bingCampaignDayMetrics[m[m.length - 2]] === undefined){
            bingCampaignDayMetrics[m[m.length - 2]] = {
                name: m[m.length - 1],
                days: {}
            }
            Object.keys(date_times).forEach(dt => {
                bingCampaignDayMetrics[m[m.length - 2]].days[dt] = {
                    date: date_times[dt],
                    clicks: 0
                }
            })
        }

        bingCampaignDayMetrics[m[m.length - 2]].days[m[m.length - 3]].clicks += parseInt(m[4])
    })
    
    perf.bingMetricsByDeviceType = sumByLastIndex(bingMetricsByDeviceType)
    perf.bingCampaignMetricsByName = sumByLastIndex(bingCampaignMetrics)
    perf.bingCampaignMetricsTotals = sumArrays(perf.bingCampaignMetricsByName.map(el => el[1]))

    perf.adsBingByDeviceDetails = perf.bingMetricsByDeviceType.map(src => ({
        id: src[0],
        sessions: src[1][3],
        goals: src[1][6],
        gcr: parseFloat(formatAverage(100 * src[1][6], src[1][3]))
    }))
    
    perf.bingCampaignDayMetrics = Object.values(bingCampaignDayMetrics).reduce((prev, curr) => {

        let mp = {
            key: curr.name,
            values: []
        }

        Object.values(curr.days).forEach(day => {
            mp.values.push({
                x: day.date,
                y: day.clicks
            })
        })

        prev.push(mp)

        return prev
    }, [])
    .sort((a,b) => perf.bingCampaignMetricsByName.find(c => c[0] ===b.key)[1][4] - perf.bingCampaignMetricsByName.find(c => c[0] ===a.key)[1][4])


    perf.bingCampaignMetricDetails = perf.bingCampaignMetricsByName.map(src => ({
        name: src[0],
        clicks: src[1][4],
        adSpend: src[1][5],
        cpc: formatAverage(src[1][5], src[1][4]),
        goals: src[1][7],
        impressions: src[1][3],
        gcr: formatPercent(src[1][7], src[1][4], true),
        cpl: src[1][7] > 0 ? formatAverage(src[1][5], src[1][7]) : 0
    }))

    perf.bingGcr = formatPercent(perf.bingGoals, totalBingClicks, true)
    perf.bingCpc = formatAverage(perf.bingAdSpend, totalBingClicks)
    perf.bingCpl = formatAverage(perf.bingAdSpend, perf.bingGoals)
    perf.bingClicks = totalBingClicks

    perf.bingCampaignMetricsPie = perf.bingCampaignMetricDetails.map(src => ({
        x: src.name,
        y: src.impressions
    })).sort((a,b) => b.y - a.y)
    
    fbFanMetrics.forEach(metric => {

        if(fbFanMetricsByDay[metric[1]] === undefined){
            fbFanMetricsByDay[metric[1]] = {}
        }

        metric[0].data.forEach(item => {
            if(item.values === null && fbFanMetricsByDay[metric[1]][item.name] === undefined){
                fbFanMetricsByDay[metric[1]][item.name] = 0
            } else if(item.values !== null && item.values?.length > 0){

                if(item.values[0].value instanceof Object && item.values[0].value !== null){
                    if(fbFanMetricsByDay[metric[1]][item.name] === undefined 
                            || fbFanMetricsByDay[metric[1]][item.name] === 0){
                        fbFanMetricsByDay[metric[1]][item.name] = {}
                    }

                    Object.keys(item.values[0].value).forEach(key => {
                        fbFanMetricsByDay[metric[1]][item.name][key] = item.values[0].value[key]
                    })
                    
                } else {
                    if(fbFanMetricsByDay[metric[1]][item.name] === undefined){
                        fbFanMetricsByDay[metric[1]][item.name] = 0
                    }
                    
                    fbFanMetricsByDay[metric[1]][item.name] += item.values ? item.values[0].value : 0
                }
            } 
        })
    });

    igMetrics.forEach(metric => {
        if(metric.length === 0 || metric[0].data === null){
            return
        }

        if(igMetricsByDay[metric[1]] === undefined){
            igMetricsByDay[metric[1]] = {}
        }

        metric[0].data.forEach(item => {
            if(item.values === null && igMetricsByDay[metric[1]][item.name] === undefined){
                igMetricsByDay[metric[1]][item.name] = 0
            }
            else if(item.values !== null && item.values?.length > 0){

                if(item.values[0].value instanceof Object && item.values[0].value !== null){
                    if(igMetricsByDay[metric[1]][item.name] === undefined 
                            || igMetricsByDay[metric[1]][item.name] === 0){
                        igMetricsByDay[metric[1]][item.name] = {}
                    }

                    Object.keys(item.values[0].value).forEach(key => {
                        igMetricsByDay[metric[1]][item.name][key] = item.values[0].value[key]
                    })
                    
                } else {
                    if(igMetricsByDay[metric[1]][item.name] === undefined){
                        igMetricsByDay[metric[1]][item.name] = 0
                    }
                    
                    igMetricsByDay[metric[1]][item.name] += item.values ? item.values[0].value : 0
                }
            } 
        })
    });
    let fbFanMetricsGrouped = Object.keys(fbFanMetricsByDay).reduce((map, date) => {
        Object.keys(fbFanMetricsByDay[date]).forEach(name => {
            if(map[name] === undefined){
                map[name] = []
                map[name+"_total"] = 0
            }

            if(fbFanMetricsByDay[date][name] instanceof Object){
                if(map[name+"_total"] === 0){
                    map[name+"_total"] = {}
                }
                Object.keys(fbFanMetricsByDay[date][name]).forEach(k => {
                    if(map[name+"_total"][k] === undefined){
                        map[name+"_total"][k] = 0
                    }
                    map[name+"_total"][k] += fbFanMetricsByDay[date][name][k]
                })
            } else {

                map[name].push([
                    date_times[date], 
                    fbFanMetricsByDay[date][name]
                ])
                if(fbFanMetricsByDay[date][name] > 0){
                    map[name+"_total"] += fbFanMetricsByDay[date][name]
                }
            }
        })

        return map 
    }, {})

    let igMetricsGrouped = Object.keys(igMetricsByDay).reduce((map, date) => {
        Object.keys(igMetricsByDay[date]).forEach(name => {
            if(map[name] === undefined){
                map[name] = []
                map[name+"_total"] = 0
            }

            if(igMetricsByDay[date][name] instanceof Object){
                if(map[name+"_total"] === 0){
                    map[name+"_total"] = {}
                }
                Object.keys(igMetricsByDay[date][name]).forEach(k => {
                    if(map[name+"_total"][k] === undefined){
                        map[name+"_total"][k] = 0
                    }
                    map[name+"_total"][k] += igMetricsByDay[date][name][k]
                })
            } else {

                map[name].push([
                    date_times[date], 
                    igMetricsByDay[date][name]
                ])
                if(igMetricsByDay[date][name] > 0){
                    map[name+"_total"] += igMetricsByDay[date][name]
                }
            }
        })

        return map 
    }, {})
    perf.date_times = date_times

    perf.fbFanMetricsGrouped = fbFanMetricsGrouped
    perf.igMetricsGrouped = igMetricsGrouped

    perf.fbFanByLikeSource = []

    if(fbFanMetricsGrouped["page_fans_by_like_source_total"]){
        Object.keys(fbFanMetricsGrouped["page_fans_by_like_source_total"]).forEach(source => {
            perf.fbFanByLikeSource.push([
                source, fbFanMetricsGrouped["page_fans_by_like_source_total"][source]
            ])
        })

        perf.fbFanByLikeSource.sort((a,b) => b[1] - a[1])
    }

    perf.fbFanImpressions = [
        { key: "Post Impressions", yAxis: 1, type:"line", values: fbFanMetricsGrouped["page_posts_impressions_unique"] || []},
        { key: "Post Engagement", yAxis: 2, type: "line", values: fbFanMetricsGrouped["page_post_engagements"] || [], color: "lightgreen"}
    ]

    perf.fbFanImpressionsByGender = []

    const genderTotals = {
        Female: 0,
        Male: 0,
        Other: 0
    }

    if(fbFanMetricsGrouped["page_impressions_by_age_gender_unique_total"]){
        Object.keys(fbFanMetricsGrouped["page_impressions_by_age_gender_unique_total"]).forEach(source => {
            if(source.includes("F.")){
                genderTotals.Female += fbFanMetricsGrouped["page_impressions_by_age_gender_unique_total"][source]
            }
            else if(source.includes("M.")){
                genderTotals.Male += fbFanMetricsGrouped["page_impressions_by_age_gender_unique_total"][source]
            }
            else {
                genderTotals.Other += fbFanMetricsGrouped["page_impressions_by_age_gender_unique_total"][source]
            }
        })

        Object.keys(genderTotals).forEach(gender => {
            perf.fbFanImpressionsByGender.push([gender, genderTotals[gender]])
        })
        perf.fbFanImpressionsByGender.sort((a,b) => b[1] - a[1])
    }



    perf.fbFanCheckins = [
        { key: "Checkins", values: fbFanMetricsGrouped["page_places_checkin_total"] || []}
    ]

    let fbActionKeys = {
        "page_call_phone_clicks_logged_in_unique": {key: "Phone calls", value: fbFanMetricsGrouped["page_call_phone_clicks_logged_in_unique_total"] },
        "page_website_clicks_logged_in_unique": {key: "Website visits", value: fbFanMetricsGrouped["page_website_clicks_logged_in_unique_total"] },
        "page_get_directions_clicks_logged_in_unique": {key: "Direction requests", value: fbFanMetricsGrouped["page_get_directions_clicks_logged_in_unique_total"] },
    }

    let fbKeysSorted = Object.keys(fbActionKeys).sort(function(a,b){return fbActionKeys[b].value-fbActionKeys[a].value})

    perf.fbActionTotals = fbKeysSorted.map(k =>
        [ fbActionKeys[k].key, fbActionKeys[k].value || 0]
    )

    perf.fbActionMetrics = fbKeysSorted.map(k => ({key: fbActionKeys[k].key, values: fbFanMetricsGrouped[k] || []}))

    perf.gmbMetrics = gmbMetrics
    perf.sourceToCampaignMap = sourceToCampaignMap

    let gmbMetricObj = gmbMetrics.reduce((map, m, index, arr) => {
        m.metricValues.forEach(v => {
            if(map[v.metric] === undefined) map[v.metric] = []
            if(map[`${v.metric}_TOTAL`] === undefined) map[`${v.metric}_TOTAL`] = 0
            map[v.metric].push([
                date_times[m.date],
                v.dimensionalValues ? parseInt(v.dimensionalValues[0].value) : 0
            ])

            map[`${v.metric}_TOTAL`] += v.dimensionalValues ? parseInt(v.dimensionalValues[0].value) : 0
        })

        return map
    }, {})


    let gbpMetricObj = gbpMetrics.reduce((map, m, index, arr) => {
        Object.keys(m[0]).forEach(key => {
            if(map[key] === undefined) map[key] = []
            if(map[`${key}_TOTAL`] === undefined) map[`${key}_TOTAL`] = 0

            let metric = m[0][key]
            map[key].push([
                date_times[m[1]],
                metric?.value !== "" ? parseInt(metric?.value ?? 0) : 0
            ])

            map[`${key}_TOTAL`] += metric?.value !== "" ? parseInt(metric?.value ?? 0) : 0
        })

        return map
    }, {})

    let actionKeysGBP = {
        "CALL_CLICKS": {key: "Phone calls", value: gbpMetricObj["CALL_CLICKS_TOTAL"] },
        "WEBSITE_CLICKS": {key: "Website visits", value: gbpMetricObj["WEBSITE_CLICKS_TOTAL"] },
        "BUSINESS_DIRECTION_REQUESTS": {key: "Direction requests", value: gbpMetricObj["BUSINESS_DIRECTION_REQUESTS_TOTAL"] },
    }

    let keysSortedGBP = Object.keys(actionKeysGBP)
        .sort(function(a,b){return actionKeysGBP[b].value-actionKeysGBP[a].value})


    perf.gbpActionTotals = keysSortedGBP.map(k =>
        [ actionKeysGBP[k].key, actionKeysGBP[k].value || 0]
    )

    perf.gbpMetricObj = gbpMetricObj

    perf.gbpActionMetrics = keysSortedGBP
        .map(k => ({key: actionKeysGBP[k].key, values: gbpMetricObj[k] || []}))
    

    perf.gbpTotalImpressions = (gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_MAPS_TOTAL ?? 0) +
        (gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_MAPS_TOTAL ?? 0) +
        (gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH_TOTAL ?? 0) +
        (gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_SEARCH_TOTAL ?? 0)

    perf.gbpImpressionTotals = [
        {title: "Mobile", value: (gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_MAPS_TOTAL ?? 0) +
            (gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_SEARCH_TOTAL ?? 0)},
        {title: "Desktop", value: (gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_MAPS_TOTAL ?? 0) +
            (gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH_TOTAL ?? 0)},
    ]
    
    perf.gbpTotalActions = (gbpMetricObj?.CALL_CLICKS_TOTAL ?? 0) +
        (gbpMetricObj?.WEBSITE_CLICKS_TOTAL ?? 0) +
        (gbpMetricObj?.BUSINESS_DIRECTION_REQUESTS_TOTAL ?? 0)
    
    perf.gbpImpressionMetrics = [
        { key: "Listings on Search (Desktop)", values: gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH || [], type: "area", yAxis: 1, maxValue: gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH_TOTAL ?? 0},
        { key: "Listings on Search (Mobile)", values: gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_SEARCH || [], type: "area", yAxis: 1, maxValue: gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_SEARCH_TOTAL ?? 0},
        { key: "Listings on Maps (Desktop)", values: gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_MAPS || [], type: "area", yAxis: 1, maxValue: gbpMetricObj?.BUSINESS_IMPRESSIONS_DESKTOP_MAPS_TOTAL ?? 0},
        { key: "Listings on Maps (Mobile)", values: gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_MAPS || [], type: "area", yAxis: 1, maxValue: gbpMetricObj?.BUSINESS_IMPRESSIONS_MOBILE_MAPS_TOTAL ?? 0}
    ].sort((a,b) => b.maxValue - a.maxValue)


    perf.gmbTotalQueries = gmbMetricObj["QUERIES_DIRECT_TOTAL"] ? (gmbMetricObj["QUERIES_DIRECT_TOTAL"] + gmbMetricObj["QUERIES_INDIRECT_TOTAL"]) : 0
    perf.gmbTotalViews = gmbMetricObj["VIEWS_MAPS_TOTAL"] ? (gmbMetricObj["VIEWS_MAPS_TOTAL"] + gmbMetricObj["VIEWS_SEARCH_TOTAL"]) : 0
    perf.gmbTotalActions = gmbMetricObj["ACTIONS_WEBSITE_TOTAL"] ? (gmbMetricObj["ACTIONS_PHONE_TOTAL"] + gmbMetricObj["ACTIONS_WEBSITE_TOTAL"] + gmbMetricObj["ACTIONS_DRIVING_DIRECTIONS_TOTAL"]) : 0
    perf.gmbConversionRate = perf.gmbTotalActions > 0 && perf.gmbTotalQueries > 0 ? (perf.gmbTotalActions / perf.gmbTotalQueries * 100).toFixed(1) : "N/A"

    perf.gmbViewMetrics = [
        { key: "Listings on Search", values: gmbMetricObj["VIEWS_SEARCH"] || [], type: "area", yAxis: 1},
        { key: "Listings on Maps", values: gmbMetricObj["VIEWS_MAPS"] || [], type: "area", yAxis: 1}
    ]

    perf.gmbSearchTotals = [
        [ "Discovery", (gmbMetricObj["QUERIES_INDIRECT_TOTAL"] - gmbMetricObj["QUERIES_CHAIN_TOTAL"]) ] ,
        [ "Direct", gmbMetricObj["QUERIES_DIRECT_TOTAL"] ],
        [ "Branded", gmbMetricObj["QUERIES_CHAIN_TOTAL"] ] 
    ]

    let actionKeys = {
        "ACTIONS_PHONE": {key: "Phone calls", value: gmbMetricObj["ACTIONS_PHONE_TOTAL"] },
        "ACTIONS_WEBSITE": {key: "Website visits", value: gmbMetricObj["ACTIONS_WEBSITE_TOTAL"] },
        "ACTIONS_DRIVING_DIRECTIONS": {key: "Direction requests", value: gmbMetricObj["ACTIONS_DRIVING_DIRECTIONS_TOTAL"] },
    }

    let keysSorted = Object.keys(actionKeys).sort(function(a,b){return actionKeys[b].value-actionKeys[a].value})

    perf.gmbActionTotals = keysSorted.map(k =>
        [ actionKeys[k].key, actionKeys[k].value || 0]
    )

    perf.gmbMetricObj = gmbMetricObj

    perf.gmbActionMetrics = keysSorted.map(k => ({key: actionKeys[k].key, values: gmbMetricObj[k] || []}))

    const avgRating = socialReviewMetrics.reduce((avg, metric, index, arr) => {
        avg += metric.avgRating
        if(arr.length == (index + 1)){
            avg = avg / arr.filter(v => v.total > 0).length
        }
        return avg
    }, 0)

    socialReviewSummary.avgRating = Number.isNaN(avgRating) ? "N/A": Math.round(avgRating * 10) / 10

    perf.socialReviewMetrics = socialReviewMetrics
    perf.socialReviewChart = [{
            values: socialReviewMetrics.map(v => ([
                date_times[v.date],
                v.total
            ])), 
            key: 'Complete Reviews',
            color: '#4091ff', 
        },
        {
            values: socialReviewMetrics.map(v => ([
                date_times[v.date],
                avgRating > 0 ? Math.round(avgRating* 10 ) / 10: 0
            ])), 
            key: 'Average star rating',
            color:'#ff7f0e'
        }
    ]

    socialReviewSummary.neutral.percent = socialReviewSummary.neutral.count > 0 ? Math.round(socialReviewSummary.neutral.count / socialReviewSummary.total * 100) : 0
    socialReviewSummary.negative.percent = socialReviewSummary.negative.count > 0 ? Math.round(socialReviewSummary.negative.count / socialReviewSummary.total * 100) : 0
    socialReviewSummary.positive.percent = socialReviewSummary.positive.count > 0 ? Math.round(socialReviewSummary.positive.count / socialReviewSummary.total * 100) : 0

    perf.socialReviewSummary = socialReviewSummary

    perf.socialReviewTotalsByChannel = Object.keys(socialReviewTotalsByChannel).map(key => ([
        key,
        socialReviewTotalsByChannel[key].count
    ]))


    perf.socialReviewAvg = Object.keys(socialReviewTotalsByChannel).reduce((avg, key, index, arr) => {
        if(key.toLowerCase().includes("google")){
            avg.google += socialReviewTotalsByChannel[key].ratingTotal / socialReviewTotalsByChannel[key].count
        }
        else if(key.toLowerCase().includes("facebook")){
            avg.fb += socialReviewTotalsByChannel[key].ratingTotal / socialReviewTotalsByChannel[key].count
        }
        else if(key.toLowerCase().includes("yelp")){
            avg.yelp += socialReviewTotalsByChannel[key].ratingTotal / socialReviewTotalsByChannel[key].count
        }

        return avg

    }, { google: 0, yelp: 0, fb: 0})
    
    Object.keys(perf.socialReviewAvg).forEach(key => {
        perf.socialReviewAvg[key] = (Math.round(perf.socialReviewAvg[key] * 10) / 10).toFixed(1)
    })
    perf.otherAdMetrics = sumByLastIndex(otherAdMetrics)
    perf.sesByOtherAdTotals = sumArrays(perf.otherAdMetrics.map(el => el[1]))

    perf.otherAdDeviceMetrics = sumByLastIndex(otherAdDeviceMetrics)
    perf.otherAdDeviceDetails = perf.otherAdDeviceMetrics.map(src => ({
        id: src[0],
        sessions: src[1][0],
        goals: src[1][2]
    }))

    perf.userMetricsTotals = sumByLastIndex(userTypeMetrics)
    const uaUserMetricsTotals = sumByLastIndex(uaUserTypeMetrics)

    if(hasGa4){
        perf.userTypeMetrics = !perf.userMetricsTotals.find(el => el[0] === 'new' || el[0] === "returning") ? {new: Array(7), ret: Array(7)} : 
        perf.userMetricsTotals.find(el => el[0] === 'new') && perf.userMetricsTotals.find(el => el[0] === 'returning') ? 
            {new: perf.userMetricsTotals.find(el => el[0] === 'new')[1], ret: perf.userMetricsTotals.find(el => el[0] === 'returning')[1]} :
        {new: Array(7), ret: Array(7)}
        
        if(hasUA){
            perf.uaUserTypeMetrics = uaUserMetricsTotals.length !== 2 ? {new: Array(7), ret: Array(7)} : 
                uaUserMetricsTotals.find(el => el[0] === 'New Visitor') && uaUserMetricsTotals.find(el => el[0] === 'Returning Visitor') ? 
                {new: uaUserMetricsTotals.find(el => el[0] === 'New Visitor')[1], ret: uaUserMetricsTotals.find(el => el[0] === 'Returning Visitor')[1]} :
                {new: Array(7), ret: Array(7)}
            
            
            perf.userTypeMetrics.new = [...perf.userTypeMetrics.new.map((v, key) => {
                return v + perf.uaUserTypeMetrics.new[key]
            })]
            perf.userTypeMetrics.ret = [...perf.userTypeMetrics.ret.map((v, key) => {
                return v + perf.uaUserTypeMetrics.ret[key]
            })]
        }
    } else {
        perf.userTypeMetrics = perf.userMetricsTotals.length !== 2 ? {new: Array(7), ret: Array(7)} : 
        perf.userMetricsTotals.find(el => el[0] === 'New Visitor') && perf.userMetricsTotals.find(el => el[0] === 'Returning Visitor') ? 
        {new: perf.userMetricsTotals.find(el => el[0] === 'New Visitor')[1], ret: perf.userMetricsTotals.find(el => el[0] === 'Returning Visitor')[1]} :
        {new: Array(7), ret: Array(7)}
    }
    perf.deviceCategoryMetrics = deviceCategoryMetrics
    perf.sesByDC = sumByLastIndex(deviceCategoryMetrics)
    let loadTimeByDC = sumByLastIndex(dcMetricsAdd)
    perf.sesByDC.forEach(el => {
        el[1].splice(7, 0, ...(loadTimeByDC && loadTimeByDC.find(x => x[0] === el[0]) ? loadTimeByDC.find(x => x[0] === el[0])[1] : [] ) )
    })
    perf.sesByDCTotals = sumArrays(perf.sesByDC.map(el => el[1]))
    perf.totalSessions = perf.sesByDCTotals[0]
    perf.newSessions = perf.sesByDCTotals[1]
    perf.returningSessions = Math.round(100*(perf.totalSessions-perf.newSessions)/perf.totalSessions)
    perf.goals = perf.sesByDCTotals[2]
    perf.goalConversion = Math.round(10000*perf.goals/perf.totalSessions)/100
    perf.sesByDCDetails = perf.sesByDC.map(src => ({
        id: src[0],
        sessions: src[1][0],
        retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
        goals: src[1][2],
        gcr: formatAverage(100*src[1][2], src[1][0])+'%',
        events: src[1][3],
        bounceRate: hasGa4 && hasUA ? "N/A" : hasGa4 ? formatPercent(src[1][0] - src[1][4], src[1][0]) : formatPercent(src[1][4], src[1][0]),
        sesDur: formatDuration(src[1][5], src[1][0]),
        sesPgs: formatAverage(src[1][6], src[1][0]),
        avgLoadTime: src[1][10] ? formatAverage(src[1][9], src[1][10]*1000)+' sec' : '',
    }))
    perf.goals_desktop = perf.goals_tablet = perf.goals_mobile = 0
    perf.sesByDCDetails.forEach(src => perf[`goals_${src.id}`] = Math.round(src.goals*100/perf.goals))
    perf.sesByMedium = sumByLastIndex(mediumMetrics).sort((a, b) => +a[1][0]>+b[1][0] ? -1 : +a[1][0] === +b[1][0] ? 0 : 1).slice(0, 5) // top 5 medium
    perf.sesByOtherAd = perf.otherAdMetrics.sort((a,b) => +a[1][0]>+b[1][0] ? -1 : +a[1][0] === +b[1][0] ? 0 : 1).slice(0, 5) // top 5 campaigns
    perf.sesByBrowser = sumByLastIndex(brMetrics)
    perf.sesByBrowserTop = perf.sesByBrowser.sort((a, b) => +a[1][0]>+b[1][0] ? -1 : +a[1][0] === +b[1][0] ? 0 : 1).slice(0, 5) // top 5 browsers
    perf.sesByBRTotals = sumArrays(perf.sesByBrowser.map(el => el[1]))
    perf.sesByBRDetails = perf.sesByBrowser.map(src => ({
        id: src[0],
        sessions: src[1][0],
        goals: src[1][1],
        gcr: formatAverage(100*src[1][1], src[1][0])+'%',
        avgLoadTime: src[1][3] ? formatAverage(src[1][2], src[1][3]*1000)+' sec' : '',
    }))
    perf.mobileStat = perf.sesByDC.filter(el => el[0] === 'mobile')[0]
    perf.mobileConversion = perf.mobileStat ? `${formatAverage(100*perf.mobileStat[1][2], perf.mobileStat[1][0])}%` : 'N/A'
    perf.avgPageLoadTime = formatAverage(perf.sesByBRTotals[2], perf.sesByBRTotals[3]*1000)

    perf.avgPageLoadByDay = Object.values(brMetrics.reduce((map, src, idx, arr) => {

        let pgLoad = parseFloat(src[2])
        let sample = parseFloat(src[3])
        let date = src[4]

        if(map[date] === undefined){
            map[date] = {
                date,
                pgLoad: 0,
                sample: 0,
                pageLoadAvg:0
            }
        }
        
        map[date].pgLoad += pgLoad
        map[date].sample += sample

        if(idx === arr.length - 1){
            Object.keys(map).forEach(k => {
                if(map[k].pgLoad > 0 && map[k].sample > 0){
                    map[k].pageLoadAvg = parseFloat(formatAverage(map[k].pgLoad, map[k].sample * 1000))
                }
            });
        }

        return map
    }, {}))

    perf.sesByOtherAdDetails = perf.sesByOtherAd.map(m => {
        let medium = m[0]
        let recs = []
        trafReport.forEach(dayMetrics => {
            if (dayMetrics.ga && dayMetrics.ga.reports && dayMetrics.ga.reports[6] && dayMetrics.ga.reports[6].data && dayMetrics.ga.reports[6].data.rows) {
                recs.push([dayMetrics.date, dayMetrics.ga.reports[6].data
                    .rows.filter(row => row.dimensions[0] === medium)])            
            } else if(dayMetrics?.ga?.reports && dayMetrics.ga.reports[6] && dayMetrics.ga.reports[6].rows) {
                recs.push([dayMetrics.date, dayMetrics.ga.reports[6]
                    .rows.filter(row => row.dimensionValues[0].value === medium)])
            }
        })
        return {key: medium, values: recs.map(row => [date_times[row[0]], row[1].length ?
            row[1].reduce((a, b) => a+(b.metricValues ? +b.metricValues[0].value : +b.metrics[0].values[0]), 0) : 0])}
    })

    perf.sesByMediumDetails = perf?.sesByMedium?.length > 0 ? perf.sesByMedium.map(medrec => {
        let medium = medrec[0]
        let recs = []
        trafReport.forEach((dayMetrics, key) => {
            if (dayMetrics.ga && dayMetrics.ga.reports && dayMetrics.ga.reports[0] && dayMetrics.ga.reports[0].data && dayMetrics.ga.reports[0].data.rows) {
                recs.push([dayMetrics.date, dayMetrics.ga.reports[0].data
                    .rows.filter(row => row.dimensions[0] === medium)])
            } else if(dayMetrics?.ga?.reports && dayMetrics.ga.reports[0] && dayMetrics.ga.reports[0].rows) {
                recs.push([dayMetrics.date, dayMetrics.ga.reports[0].rows.filter(row => row.dimensionValues[0].value === medium)])
            } else {
                recs.push([dayMetrics.date, {
                    metrics: [{
                        values:[0]
                    }]
                }])
            }
        })
        return {key: medium, values: recs.map(row => [date_times[row[0]], row[1].length ?
            row[1].reduce((a, b) => a+(b.metricValues ? +b.metricValues[0].value : +b.metrics[0].values[0]), 0) : 0])}
    }) : []

    perf.sesByMediumActive = perf.sesByMediumDetails.reduce((prev, curr, idx, arr) => {
        let vals = {}
        curr.values.forEach(([i, v]) => vals[i] = v)

        if(prev.totalValues === null){
            prev.totalValues = vals
        } else {
            Object.keys(vals).forEach(k => {
                prev.totalValues[k] += (vals[k] || 0)
            })
        }

        if(idx === arr.length - 1){
            prev.count = Object.values(prev.totalValues).filter(v => v > 0).length
        }

        return prev
    }, {count: 0, totalValues: null})

    let smDetails = sumByLastIndex(sourceMediumMetrics)
    let smDetailsNonCpc = sumByLastIndex(sourceMediumMetricsNonCpc)
    let mDetails = sumByLastIndex(mediumMetrics)
    let emailSmDetails = sumByLastIndex(emailSrcMedMetrics)
    let emailSmMobDetails = sumByLastIndex(emailMobSrcMedMetrics)

    perf.emailDeviceTotals = sumByLastIndex(emailDeviceMetrics)

    perf.emailSmTotals = sumArrays(emailSmDetails.map(el => el[1]))
    perf.emailCampaignTotals = perf.emailSmTotals.slice(0)

    perf.emailByCampaign = sumByLastIndex(emailSrcMedMetrics).sort((a, b) => +a[1][0]>+b[1][0] ? -1 : +a[1][0] === +b[1][0] ? 0 : 1).slice(0, 5) // top 5 medium

    perf.emailSmMobTotals = sumArrays(emailSmMobDetails.map(el => el[1]))
    perf.emailCampaignMobTotals = perf.emailSmMobTotals.slice(0)
    
    let mMobDetails = sumByLastIndex(mobileMediumMetrics)
    let smMobDetails = sumByLastIndex(mobileSourceMediumMetrics)
    let smMobDetailsNonCpc = sumByLastIndex(mobileSourceMediumMetricsNonCpc)

    perf.sesTotals = perf.sesByDCTotals.slice(0)
    perf.sesMobTotals = sumArrays(smMobDetails.map(el => el[1]))
    let accessor =function(s,l,a,i){var v8,v9,v10,v11,v12,v13=l&&('attr' in l);if(!(v13)){if(s){v12=s.attr;}}else{v12=l.attr;}if(v12!=null){v11=v12.accounts;}else{v11=undefined;}if(v11!=null){v10=v11.ga;}else{v10=undefined;}if(v10!=null){v8=v10.goals;}else{v8=undefined;}if(v8!=null){v9=v8.items;}else{v9=undefined;}return v9;};
    accessor.assign=function(s,v,l){var v0,v1,v2,v3,v4,v5,v6,v7=l&&('attr' in l);if(!(v7)){if(s){if(s.attr==null){s.attr={};}v6=s.attr;}}else{v6=l.attr;}if(v6!=null){if(v6.accounts==null){v6.accounts={};}v5=v6.accounts;}else{v5=undefined;}if(v5!=null){if(v5.ga==null){v5.ga={};}v4=v5.ga;}else{v4=undefined;}if(v4!=null){if(v4.goals==null){v4.goals={};}v2=v4.goals;}else{v2=undefined;}if(v2!=null){v3=v2.items;}else{v3=undefined;}if(v2!=null){v1=v;v0=v2.items=v1;}return v0;}

    let goalsByTypeDate = []

    if (accessor(site)) {
        perf.goalsByType = []
        let items = accessor(site), summary_goals = {}
        for (let i=1; i<=20; i++) {
            if (!(i in items)) {
                continue
            }
            let goal = goals[`goal${i}`], goalCnt = goal && goal.reduce((a, b) => a+(+b[2]), 0)
            if(goal){
                let goalItem = {
                    key: items[i].name,
                    values: [],
                    // type: "area",
                    // yAxis: 1
                }

                let goalItemArr = sumByLastIndex(goal)

                goalItem.values.push(...Object.values(date_times).map(millis => {
                    let found = goalItemArr.find(gi => parseInt(gi[0]) === millis)
                    if(found){
                        return [ parseInt(found[0]), found[1][2] ]
                    } else {
                        return [ millis, 0 ]
                    }
                }))

                goalsByTypeDate.push(goalItem)
            }
            let line = {
                name: items[i].name,
                goals: !goal ? 0 : goalCnt,
                mobGoals: !goal ? 0 : goal.filter(el => el[0]==='mobile').reduce((a, b) => a+(+b[2]), 0),
                newGoals: !goal ? 0 : goal.filter(el => el[1]==='New Visitor').reduce((a, b) => a+(+b[2]), 0),
                value: !goal ? 0 : goalCnt*(+items[i].value)
            }
            if (!(line.name in summary_goals)) {
                summary_goals[line.name] = line
            } else {
                summary_goals[line.name].goals += line.goals
                summary_goals[line.name].mobGoals += line.mobGoals
                summary_goals[line.name].newGoals += line.newGoals
                summary_goals[line.name].value += line.value
            }
        }
        perf.goalsByType =  Object.keys(summary_goals).map(gl => summary_goals[gl])
        perf.goalsByType.sort((a, b) => b.goals-a.goals)
        perf.goalsByType = perf.goalsByType.filter(x => x.goals > 0)
    }

    if(hasGa4){

        const goalsByTypeGa4 = evMetrics.filter(e => e[e.length - 1] == "true").reduce((prev, curr, idx, arr) => {
            if(prev.goalsByType[curr[curr.length - 2]] === undefined){
                prev.goalsByType[curr[curr.length - 2]] = {
                    name: curr[curr.length - 2],
                    goals: 0,
                    mobGoals: 0,
                    newGoals: 0,
                    value: 0
                }

                prev.goalsByTypeDate[curr[curr.length - 2]] = {
                    key: curr[curr.length - 2],
                    values: {}
                }

                
                Object.values(date_times).forEach(millis => {
                    prev.goalsByTypeDate[curr[curr.length - 2]].values[millis] = [millis, 0]
                })
            }

            prev.goalsByType[curr[curr.length - 2]].goals += +curr[1]

            if(curr[curr.length - 3] === "mobile"){
                prev.goalsByType[curr[curr.length - 2]].mobGoals += +curr[1]
            }

            if(curr[curr.length - 4] && curr[curr.length - 4].includes("new")){
                prev.goalsByType[curr[curr.length - 2]].newGoals += +curr[1]
            }

            if(prev.goalsByTypeDate[curr[curr.length - 2]].values[date_times[curr[2]]] === undefined){
                prev.goalsByTypeDate[curr[curr.length - 2]].values[date_times[curr[2]]] = [date_times[curr[2]], 0]
            }

            prev.goalsByTypeDate[curr[curr.length - 2]].values[date_times[curr[2]]][1] += +curr[1]

            if(idx === arr.length - 1){
                prev.goalsByTypeDate = [...Object.values(prev.goalsByTypeDate).map(g => ({
                    ...g,
                    values: Object.values(g.values)
                }))]

                prev.goalsByType = Object.values(prev.goalsByType)
            }

            return prev
        }, {
            goalsByType: {},
            goalsByTypeDate: {}
        })

        let missingUATypes = []

        let combGoalsByType = goalsByTypeGa4.goalsByType.length > 0 ? perf?.goalsByType?.length > 0 ? goalsByTypeGa4.goalsByType.map((g) => {
            const uaType = perf.goalsByType.find(uaG => uaG.name === g.name)
            if(uaType){
                return {
                    name: g.name,
                    goals: g.goals + uaType.goals,
                    mobGoals: g.mobGoals + uaType.mobGoals,
                    newGoals: g.newGoals + uaType.newGoals,
                    value: g.value + uaType.value
                }
            } else {
                return {
                    name: g.name,
                    goals: g.goals,
                    mobGoals: g.mobGoals,
                    newGoals: g.newGoals,
                    value: g.value
                }
            }
        }) : goalsByTypeGa4.goalsByType : []
        if(perf?.goalsByType?.length > 0){
            perf.goalsByType.forEach((g) => {
                const uaType = combGoalsByType.length > 0 ? combGoalsByType.find(uaG => uaG.name === g.name) : true

                if(!uaType){
                    missingUATypes.push({
                        name: g.name,
                        goals: g.goals,
                        mobGoals: g.mobGoals,
                        newGoals: g.newGoals,
                        value: g.value
                    })
                }
            })
        }
        perf.goalsByType = [...combGoalsByType, ...missingUATypes]
        perf.goalsByType.sort((a, b) => b.goals-a.goals)

        perf.goalsByTypeDate = [...goalsByTypeDate, ...(Object.keys(goalsByTypeGa4.goalsByTypeDate).length > 0 ? goalsByTypeGa4.goalsByTypeDate : [])]
    } else {        
        perf.goalsByTypeDate = goalsByTypeDate
    }

    const leadsBySrcMed = leadsBySrcMedHour.reduce((map, curr, idx, arr) => {
        let leads = parseInt(curr[0])

        if(map[curr[2]] === undefined ){
            map[curr[2]] = { srcMed: curr[2], total: 0, valueAfterHours: 0, emailTotal: 0, emailValueAfterHours: 0}
        }

        map[curr[2]].total += leads
        if(curr[2].includes('email')){
            map[curr[2]].emailTotal += leads
        }

        if(parseInt(curr[3]) >= 17 || parseInt(curr[3]) <= 8) {
            map[curr[2]].valueAfterHours += leads
            if(curr[2].includes('email')){
                map[curr[2]].emailValueAfterHours += leads
            }
        }

        return map
    }, {})

    perf.goalsAfterHours = Object.values(leadsBySrcMed).length > 0 ? Object.values(leadsBySrcMed).reduce((num, item) => {
        if(item.valueAfterHours > 0){
            num += item.valueAfterHours
        }

        return num
    }, 0) : 0

    perf.goalsEmailAfterHours = Object.values(leadsBySrcMed).length > 0 ? Object.values(leadsBySrcMed).reduce((num, item) => {
        if(item.emailValueAfterHours > 0){
            num += item.emailValueAfterHours
        }

        return num
    }, 0) : 0
    
    perf.avgGoalsAfterHours = perf.sesTotals[2] > 0 && perf.goalsAfterHours > 0 ? (perf.goalsAfterHours/ perf.sesTotals[2] * 100).toFixed(0) : 0

    perf.avgGoalsEmailAfterHours = perf.emailCampaignTotals[2] > 0 && perf.goalsEmailAfterHours > 0 ? (perf.goalsEmailAfterHours/ perf.emailCampaignTotals[2] * 100).toFixed(0) : 0

    perf.sesBySrcMediumDetails = smDetails.map(src => {
        let mobDetails = smMobDetails.find(srcMob => srcMob[0] === src[0]) || [0, [1, 0, 0]]
        return {
            id: src[0],
            sessions: src[1][0],
            retUserSess: src[1][1],
            retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
            goals: src[1][2],
            gcr: formatAverage(100*src[1][2], src[1][0])+'%',
            mobileGoals: mobDetails[1][2],
            mobileGcr: formatAverage(100*mobDetails[1][2], mobDetails[1][0])+'%',
            mobileSessions: mobDetails[1][0],
            events: src[1][3],
            bounces: hasGa4 && hasUA ? "N/A" : hasGa4 ? src[1][0] - src[1][4] : src[1][4],
            sesDurIncr: src[1][5],
            sesPgsIncr: src[1][6],
            goalsAfterHours: leadsBySrcMed[src[0]] ? leadsBySrcMed[src[0]].valueAfterHours : 0,
            bounceRate: hasGa4 && hasUA ? "N/A" : hasGa4 ? formatPercent(src[1][0] - src[1][4], src[1][0]) : formatPercent(src[1][4], src[1][0]),
            sesDur: formatDuration(src[1][5], src[1][0]),
            sesPgs: formatAverage(src[1][6], src[1][0]),
            goalsAfterHoursPct: leadsBySrcMed[src[0]] && src[1][2] > 0 ? (leadsBySrcMed[src[0]]?.valueAfterHours / src[1][2] * 100).toFixed(0) : 0,
            daily: sumByLastIndex(sourceMediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][0]]),
            dailyLeads: sumByLastIndex(sourceMediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][2]]),
        }
    })

    perf.sesBySrcMediumDetailsNonCpc = smDetailsNonCpc.map(src => {
        let mobDetails = smMobDetailsNonCpc.find(srcMob => srcMob[0] === src[0]) || [0, [1, 0, 0]]
        return {
            id: src[0],
            sessions: src[1][0],
            retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
            goals: src[1][2],
            gcr: formatAverage(100*src[1][2], src[1][0])+'%',
            mobileGoals: mobDetails[1][2],
            mobileGcr: formatAverage(100*mobDetails[1][2], mobDetails[1][0])+'%',
            events: src[1][3],
            bounces: hasGa4 ? src[1][0] - src[1][4] : src[1][4],
            bounceRate: formatPercent(hasGa4 ? src[1][0] - src[1][4] : src[1][4], src[1][0]),
            sesDur: formatDuration(src[1][5], src[1][0]),
            sesPgs: formatAverage(src[1][6], src[1][0]),
            goalsAfterHoursPct: leadsBySrcMed[src[0]] && src[1][2] > 0 ? (leadsBySrcMed[src[0]].valueAfterHours / src[1][2] * 100).toFixed(0) : 0,
            daily: sumByLastIndex(sourceMediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][0]]),
            dailyLeads: sumByLastIndex(sourceMediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][2]]),
        }
    })

    let goalsBySrcMedDate = []

    perf.sesBySrcMediumDetails.sort((a, b) => b.goals - a.goals)
        .slice(0,5)
        .forEach((m, k) => {

        let srcMedItem = {
            key: m.id,
            bar: true,
            stacked: true,
            values: []
        }

        srcMedItem.values.push(...Object.keys(date_times).map(dt => {
            let lead = m.dailyLeads.find(day => day[0] === dt)
            let millis = date_times[dt]
            
            if(lead){   
                return [ parseInt(millis), lead[1] ]
            } else {
                return [ parseInt(millis), 0 ]
            }
        }))

        goalsBySrcMedDate.push(srcMedItem)
    })

    perf.goalsBySrcMedDate = goalsBySrcMedDate


    perf.goalsBySrcMedActive = perf.goalsBySrcMedDate.reduce((prev, curr, idx, arr) => {
        let vals = {}
        curr.values.forEach(([i, v]) => vals[i] = v)

        if(prev.totalValues === null){
            prev.totalValues = vals
        } else {
            Object.keys(vals).forEach(k => {
                prev.totalValues[k] += (vals[k] || 0)
            })
        }

        if(idx === arr.length - 1){
            prev.count = Object.values(prev.totalValues).filter(v => v > 0).length
        }

        return prev
    }, {count: 0, totalValues: null})

    const mobSesByEmailCampaignDetails = emailMobSrcMedMetrics.reduce((prev, curr, idx, arr) => {
        if(prev[curr[curr.length - 1]] === undefined){
            prev[curr[curr.length - 1]] = {}
        }

        if(prev[curr[curr.length - 1]][curr[curr.length - 2]] === undefined){
            prev[curr[curr.length - 1]][curr[curr.length - 2]] = {
                id: curr[curr.length - 1],
                source: curr[curr.length - 2],
                sessions: 0,
                retSess: 0,
                goals: 0,
                gcr: 0,
                bounceRate: 0,
                sesDur: 0,
                sesPgs: 0
            }
        }

        prev[curr[curr.length - 1]][curr[curr.length - 2]].sessions += +curr[0]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].goals += +curr[2]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].retSess += +curr[3]

        if(idx === arr.length - 1){
            Object.keys(prev).forEach(campaign => {
                Object.keys(prev[campaign]).forEach(source => {
                    prev[campaign][source].gcr = formatAverage(100*prev[campaign][source].goals, prev[campaign][source].sessions)+'%'
                    prev[campaign][source].bounceRate = hasGa4 && hasUA ? "N/A" : hasGa4 ? formatPercent( prev[campaign][source].sessions -  prev[campaign][source].retSess,  prev[campaign][source].sessions) : formatPercent( prev[campaign][source].retSess,  prev[campaign][source].sessions)
                })
            })

            Object.keys(prev).forEach(campaign => {
                prev.arr.push(...Object.values(prev[campaign]))

            })
        }

        return prev
        
    }, {
        arr: []
    })

    perf.sesByEmailCampaignsDaily = emailSrcMedMetrics.reduce((prev, curr, idx, arr) => {
        if(prev[curr[curr.length - 1]] === undefined){
            prev[curr[curr.length - 1]] = {
                id: curr[curr.length - 1],
                sessions: 0,
                dates: {}
            }
        }

        if(prev[curr[curr.length - 1]].dates[curr[curr.length - 3]] === undefined){
            prev[curr[curr.length - 1]].dates[curr[curr.length - 3]] = {
                sessions: 0,
                goals: 0
            }
        }
        prev[curr[curr.length - 1]].sessions += +curr[0]

        prev[curr[curr.length - 1]].dates[curr[curr.length - 3]].sessions += +curr[0]        
        prev[curr[curr.length - 1]].dates[curr[curr.length - 3]].goals += +curr[2] 
        
        if(idx === arr.length - 1){
            prev = Object.values(prev)
        }
        
        return prev
    }, {})

    perf.sesByEmailCampaignDetails = emailSrcMedMetrics.reduce((prev, curr, idx, arr) => {
        if(prev[curr[curr.length - 1]] === undefined){
            prev[curr[curr.length - 1]] = {}
        }

        if(prev[curr[curr.length - 1]][curr[curr.length - 2]] === undefined){
            prev[curr[curr.length - 1]][curr[curr.length - 2]] = {
                id: curr[curr.length - 1],
                source: curr[curr.length - 2],
                sessions: 0,
                retSess: 0,
                goals: 0,
                gcr: 0,
                bounceRate: 0,
                sesDur: 0,
                sesPgs: 0,
                engagedSess: 0
            }
        }

        prev[curr[curr.length - 1]][curr[curr.length - 2]].sessions += +curr[0]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].retSess += +curr[1]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].goals += +curr[2]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].engagedSess += +curr[3]

        if(idx === arr.length - 1){
            Object.keys(prev).forEach(campaign => {
                Object.keys(prev[campaign]).forEach(source => {
                    let mobDetails = mobSesByEmailCampaignDetails[campaign] ? mobSesByEmailCampaignDetails[campaign][source] ?? {} : {}
                    prev[campaign][source].gcr = formatAverage(100*prev[campaign][source].goals, prev[campaign][source].sessions)+'%'
                    prev[campaign][source].bounceRate = formatPercent( prev[campaign][source].sessions -  prev[campaign][source].engagedSess,  prev[campaign][source].sessions)
                    
                    prev[campaign][source].mobileGoals = mobDetails?.goals ?? 0
                    prev[campaign][source].mobileGcr = mobDetails?.goals > 0 && mobDetails?.sessions > 0 ? 
                        formatAverage(100*mobDetails?.goals, mobDetails?.sessions)+'%' : 0
                    
                    prev[campaign][source].retSess = formatPercent(prev[campaign][source].sessions - prev[campaign][source].retSess, prev[campaign][source].sessions)
                    
                    prev[campaign][source].daily = sumByLastIndex(arr
                        .filter(x => x.slice(-1)[0] === curr[curr.length - 1] && x.slice(-2)[0] === curr[curr.length - 2])
                        .map(x => [...x, x.slice(-3)[0]])).map(x => [x[0], x[1][0]])
                    prev[campaign][source].dailyLeads= sumByLastIndex(arr
                        .filter(x => x.slice(-1)[0] === curr[curr.length - 1] && x.slice(-2)[0] === curr[curr.length - 2])
                        .map(x => [...x, x.slice(-3)[0]])).map(x => [x[0], x[1][2]])
                })
            })

            Object.keys(prev).forEach(campaign => {
                prev.arr.push(...Object.values(prev[campaign]))

            })
        }

        return prev
        
    }, {
        arr: []
    }).arr

    // map(src => {
    //     let mobDetails = emailSmMobDetails.find(srcMob => srcMob[0] === src[0]) || [0, [1, 0, 0]]
    //     return {
    //         id: src[0],
    //         source: sourceToCampaignMap[src[0]],
    //         sessions: src[1][0],
    //         retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
    //         goals: src[1][2],
    //         gcr: formatAverage(100*src[1][2], src[1][0])+'%',
    //         mobileGoals: mobDetails[1][2],
    //         mobileGcr: formatAverage(100*mobDetails[1][2], mobDetails[1][0])+'%',
    //         bounceRate: hasGa4 ? formatPercent(src[1][0] - src[1][3], src[1][0]) : formatPercent(src[1][3], src[1][0]),
    //         sesDur: formatDuration(src[1][4], src[1][0]),
    //         sesPgs: formatAverage(src[1][5], src[1][0]),
    //         daily: sumByLastIndex(emailSrcMedMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-3)[0]])).map(x => [x[0], x[1][0]]),
    //         dailyLeads: sumByLastIndex(emailSrcMedMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-3)[0]])).map(x => [x[0], x[1][2]]),
    //     }
    // })

    perf.emailDailySessions = sumByLastIndex(emailSrcMedMetrics.map(x => [...x, x.slice(-3)[0]])).map(x => [x[0], x[1][0]])
    perf.emailDailyLeads = sumByLastIndex(emailSrcMedMetrics.map(x => [...x, x.slice(-3)[0]])).map(x => [x[0], x[1][2]])
    perf.sesByMediumTblDetails = mDetails.map(src => {
        let mDet = mMobDetails.find(srcMob => srcMob[0] === src[0]) || [0, [1, 0, 0]]
        return {
            id: src[0],
            sessions: src[1][0],
            retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
            goals: src[1][2],
            gcr: formatAverage(100*src[1][2], src[1][0])+'%',
            mobileGoals: mDet[1][2],
            mobileGcr: formatAverage(100*mDet[1][2], mDet[1][0])+'%',
            mobileSessions: mDet[1][0],
            events: src[1][3],
            bounceRate: hasGa4 && hasUA ? "N/A" : hasGa4 ? formatPercent(src[1][0] - src[1][4], src[1][0]) : formatPercent(src[1][4], src[1][0]),
            sesDur: formatDuration(src[1][5], src[1][0]),
            sesPgs: formatAverage(src[1][6], src[1][0]),
            // goalsAfterHoursPct: leadsBySrcMed[src[0]] && src[1][2] > 0 ? (leadsBySrcMed[src[0]].valueAfterHours / src[1][2] * 100).toFixed(0) : 0,
            // daily: sumByLastIndex(mediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][0]]),
            // dailyLeads: sumByLastIndex(sourceMediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][2]]),
        }
    })

    perf.leadsTotalByHour = leadsBySrcMedHour.reduce((map, curr, idx, arr) => {

        map.value += parseInt(curr[0])

        if(parseInt(curr[3]) >= 17 || parseInt(curr[3]) <= 8) {
            map.valueAfterHours += parseInt(curr[0])
        }

        if(idx === (arr.length - 1)) {
            map.percent = (map.valueAfterHours / parseInt(perf.goals) * 100).toFixed(0)
        }

        return map
    }, { value:0, percent: 0, valueAfterHours: 0})


    const leadObjInit = {}

    for(let i = 0; i <= 23; i ++){
        leadObjInit[`${i}`] = {
            "Sun": 0,
            "Mon": 0,
            "Tue": 0,
            "Wed": 0,
            "Thu": 0,
            "Fri": 0,
            "Sat": 0
        }
    }

    perf.leadsTotalByWeekdayHour = leadsBySrcMedHour.reduce((map, curr) => {
        const dt = DateTime.fromISO(curr[1])
        const dayOfWeek = dt.toFormat("ccc")
        const hourOfDay = parseInt(curr[3])

        if(!Number.isNaN(hourOfDay)){
            map[`${hourOfDay}`][dayOfWeek] += parseInt(curr[0])
        }

        return map
    }, {...leadObjInit})

    perf.leadsTotalByMedTbl = Object.values(perf.sesBySrcMediumDetails.reduce((map, m, idx, arr) => {
        let sessions = parseInt(m.sessions)
        let goals = parseInt(m.goals)
        let mobGoals = parseInt(m.mobileGoals)
        let mobSessions = parseInt(m.mobileSessions)
        let medium = m.id

        if(map[medium] === undefined){
            map[medium] = {
                medium,
                goals: 0,
                sessions: 0,
                mobGoals: 0,
                mobSessions: 0,
                goalsAfterHours: 0,
                goalsAfterHoursPercent: 0,
                mobGcr: 0,
                gcr: 0,
                totalMobile: 0
            }
        }

        map[medium].goals += goals
        map[medium].sessions += sessions

        if(mobGoals > 0){
            map[medium].mobSessions += mobSessions
            map[medium].mobGoals += mobGoals

            map[medium].totalMobile += 1
        }

        if(leadsBySrcMed[medium] && leadsBySrcMed[medium].valueAfterHours > 0){
            map[medium].goalsAfterHours = leadsBySrcMed[medium].valueAfterHours
        }

        if(idx === arr.length -1){
            Object.keys(map).forEach(key => {
                map[key].gcr = (map[key].goals / map[key].sessions * 100).toFixed(2)
                if(map[key].mobGoals > 0 && map[key].mobSessions > 0){
                    map[key].mobGcr = (map[key].mobGoals / map[key].mobSessions * 100).toFixed(2)
                }

                if(map[key].goals > 0 && map[key].goalsAfterHours > 0){
                    map[key].goalsAfterHoursPercent = (map[key].goalsAfterHours / map[key].goals * 100).toFixed(0)
                }
            })
        }

        return map

    }, {}))
    // const leadsByCampaign = otherAdMetrics.reduce((map, curr, idx, arr) => {
    //     let leads = parseInt(curr[2])

    //     if(map[curr[7]] === undefined ){
    //         map[curr[7]] = { total: 0, valueAfterHours: 0}
    //     }

    //     map[curr[7]].total += leads

    //     if(parseInt(curr[3]) >= 17 || parseInt(curr[3]) <= 8) {
    //         map[curr[2]].valueAfterHours += leads
    //     }

    //     return map
    // }, {})

    

    function isNumber (value) {
        if (typeof value !== 'number') {
          return false
        }
      
        if (value !== Number(value)) {
          return false
        }
        
        if (Number.isFinite(value) === false) {
          return false
        }
      
        return true
      }

    perf.sesBySrcMediumOrganicSum = perf.sesBySrcMediumDetails.reduce((map, item) => {
        if(item.id.includes("organic")){
            map.count ++
            Object.keys(item).forEach(k => {
                if(isNumber(item[k])) {
                    map[k] += item[k]
                }
            })
        }

        return map
    }, {
        count: 0,
        sessions: 0,
        retSess: 0,
        retUserSess: 0,
        goals: 0,
        gcr: 0,
        mobileSessions: 0,
        mobileGoals: 0,
        mobileGcr: 0,
        events: 0,
        bounces: 0,
        bounceRate: 0,
        sesDur: 0,
        sesPgs: 0,
        daily: 0,
        dailyLeads: 0,
    })

    perf.sesBySrcMediumOrganicSum.retSess = formatPercent(perf.sesBySrcMediumOrganicSum.sessions - perf.sesBySrcMediumOrganicSum.retUserSess, perf.sesBySrcMediumOrganicSum.sessions)

    perf.sesBySrcMediumAISum = perf.sesBySrcMediumDetails.reduce((map, item) => {
        let source = item.id.split("/")[0].trim()
        if(item.id.includes("ai-assistant") || aiAssistants.includes(source)){
            map.count ++
            Object.keys(item).forEach(k => {
                if(isNumber(item[k])) {
                    map[k] += item[k]
                }
            })
        }

        return map
    }, {
        count: 0,
        sessions: 0,
        retSess: 0,
        retUserSess: 0,
        goals: 0,
        gcr: 0,
        mobileSessions: 0,
        mobileGoals: 0,
        mobileGcr: 0,
        events: 0,
        bounces: 0,
        bounceRate: 0,
        sesDur: 0,
        sesPgs: 0,
        daily: 0,
        dailyLeads: 0,
    })

    perf.sesBySrcMediumAISum.retSess = formatPercent(perf.sesBySrcMediumAISum.sessions - perf.sesBySrcMediumAISum.retUserSess, perf.sesBySrcMediumAISum.sessions)

    perf.totalBounces = hasGa4 && hasUA ? "N/A" : hasGa4 ? perf.sesTotals[0] - perf.sesTotals[4] : perf.sesTotals[4] 
    perf.loadByDay = [
        {key: 'Load Time (Sec)', values: sumByLastIndex(ldMetrics).map(row => [date_times[row[0]], row[1][3] ? row[1][2]/row[1][3]/1000 : 0])},
        {key: 'Daily Average', values: sumByLastIndex(ldMetrics).map(row => [date_times[row[0]], perf.avgPageLoadTime]), color: '#ff7f0e' }
    ]
    perf.goalsByDay = [
        {key: 'Goal Completions', values: sumByLastIndex(goalMetrics).map(row => [date_times[row[0]], row[1][0]]), color: '#7777ff', yAxis: 1, type:"line"},
        {key: 'Daily Average', values: sumByLastIndex(goalMetrics).map(row => [date_times[row[0]], perf.goals/trafReport.length]), color: '#ff7f0e', yAxis: 1, type:"line"},
    ]

    let eventActionRows = Object.values(evMetrics.reduce((prev, curr, idx, arr) => {
        let type = curr[curr.length - 5]
        let category = type.hasGA4 ? "(not set)" : curr[curr.length - 1]
        let action = curr[curr.length - 2]
        
        if(prev[category] === undefined){
            prev[category] = {
                [action]: [
                    category,
                    action,
                    0,
                    0
                ]
            }
        }

        if(prev[category][action] === undefined){
            prev[category][action] = [
                category,
                action,
                0,
                0
            ]
        }

        prev[category][action][2] += parseInt(curr[0])
        prev[category][action][3] += 1

        if(arr.length - 1 === idx){
            Object.keys(prev).forEach(c => {
                prev[c] = Object.values(prev[c])
            })
        }

        return prev
    }, {}))

    perf.eventActionRows = [].concat.apply([], eventActionRows)


    perf.otherAdMetricsByDate = otherAdMetrics.reduce((prev, curr) => {
        if(prev[curr[curr.length - 3]] === undefined){
            prev[curr[curr.length - 3]] = {
                goals: 0,
                sessions: 0
            }

        }
        prev[curr[curr.length - 3]].sessions += +curr[0]
        prev[curr[curr.length - 3]].goals += +curr[2]

        return prev
    }, {})
    
    perf.adMetricsByDate = adMetrics.reduce((prev, curr) => {
        if(prev[curr[curr.length - 3]] === undefined){
            prev[curr[curr.length - 3]] = {
                goals: 0,
                sessions: 0
            }

        }
        prev[curr[curr.length - 3]].sessions += +curr[0]
        prev[curr[curr.length - 3]].goals += +curr[5]

        return prev
    }, {})
    perf.adsByCompaign = sumByLastIndex(adMetrics)
    perf.adsByCompaignTop = perf.adsByCompaign.sort((a, b) => +a[1][2]>+b[1][2] ? -1 : +a[1][2] === +b[1][2] ? 0 : 1).slice(0, 5) // top 5 clicks
    perf.adsByCompaignDetails = perf.adsByCompaignTop.map(ad => {
        let campaign = ad[0]
        let recs = []
        trafReport.forEach(dayMetrics => {
            if (dayMetrics.ga && dayMetrics.ga.reports && dayMetrics.ga.reports[5] && dayMetrics.ga.reports[5].data && dayMetrics.ga.reports[5].data.rows) {
                recs.push([dayMetrics.date, dayMetrics.ga.reports[5].data
                    .rows.filter(row => row.dimensions[0] === campaign)])
            } else if (dayMetrics?.ga?.reports && dayMetrics.ga.reports[5] && dayMetrics.ga.reports[5].rows) {
                recs.push([dayMetrics.date, dayMetrics.ga.reports[5]
                    .rows.filter(row => row.dimensionValues[0].value === campaign)])
            }
        })
        return {key: campaign, values: recs.map(row => [date_times[row[0]], row[1].length ?
            row[1].reduce((a, b) => a+(b.metricValues ? +b.metricValues[2].value : +b.metrics[0].values[2]), 0) : 0])}
    })
    perf.adsByCompaignTotal = sumArrays(perf.adsByCompaign.map(el => el[1]))
    perf.adsByDevice = sumByLastIndex(adMetrics.map(el => [...el, el[el.length-2]]))

    perf.adsByDeviceDetails = perf.adsByDevice.sort((a, b) => +a[1][3]>+b[1][3] ? -1 : +a[1][3] === +b[1][3] ? 0 : 1).map(src => ({
        id: src[0],
        goals: src[1][5],
        gcr: parseFloat(formatAverage(100*src[1][5], src[1][0]))
    }))

    
    perf.adsByCompaignOtherDetails = Object.values(otherAdMetrics).reduce((prev, curr, idx, arr) => {
        if(prev[curr[curr.length - 1]] === undefined){
            prev[curr[curr.length - 1]] = {}
        }

        if(prev[curr[curr.length - 1]][curr[curr.length - 2]] === undefined){
            prev[curr[curr.length - 1]][curr[curr.length - 2]] = {
                id: curr[curr.length - 1],
                source: curr[curr.length - 2],
                sessions: 0,
                retSess: 0,
                goals: 0,
                gcr: 0,
                bounceRate: 0,
                sesDur: 0,
                sesPgs: 0,
                engagedSess: 0
            }
        }

        prev[curr[curr.length - 1]][curr[curr.length - 2]].sessions += +curr[0]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].retSess += +curr[1]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].goals += +curr[2]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].engagedSess += +curr[3]

        if(idx === arr.length - 1){
            Object.keys(prev).forEach(campaign => {
                Object.keys(prev[campaign]).forEach(source => {
                    prev[campaign][source].gcr = formatAverage(100*prev[campaign][source].goals, prev[campaign][source].sessions)+'%'
                    prev[campaign][source].bounceRate = formatPercent( prev[campaign][source].sessions - prev[campaign][source].engagedSess,  prev[campaign][source].sessions)

                    prev[campaign][source].retSess = formatPercent(prev[campaign][source].sessions - prev[campaign][source].retSess, prev[campaign][source].sessions)
                })
            })

            Object.keys(prev).forEach(campaign => {
                prev.arr.push(...Object.values(prev[campaign]))

            })
        }

        return prev
    }, {
        arr: []
    }).arr

    // .reduce(src => {
    //     // let mobDetails = mobileOtherAdMetrics.find(srcMob => srcMob[0] === src[0]) || [0, [1, 0, 0]]
    //     return {
    //         id: src[0],
    //         source: sourceToCampaignMap[src[0]],
    //         sessions: src[1][0],
    //         retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
    //         goals: src[1][2],
    //         gcr: formatAverage(100*src[1][2], src[1][0])+'%',
    //         // mobileGoals: mobDetails[1][2],
    //         // mobileGcr: formatAverage(100*mobDetails[1][2], mobDetails[1][0])+'%',
    //         bounceRate: hasGa4 && hasUA ? "N/A" : hasGa4 ? formatPercent(src[1][0] - src[1][3], src[1][0]) : formatPercent(src[1][3], src[1][0]),
    //         sesDur: formatDuration(src[1][4], src[1][0]),
    //         sesPgs: formatAverage(src[1][5], src[1][0])
    //     }
    // }))
    
    let leadTypes = ['LEAD_GENERATION', 'CONVERSIONS', 'OUTCOME_LEADS']

    let get_action = (row, id, new_switch=false) => {
        let param = new_switch ? "actions" : "unique_actions"
        if (!row[param]) {
            return 0
        }
        if(Array.isArray(id)){
            let returnVal = 0
            
            id.forEach(i => {
                let act = row[param].filter(x => x.action_type === i)
                if(i.includes("custom")){
                    act = row[param].filter(x => x.action_type.includes(i))
                }

                if(act.length){
                    returnVal = +act[0].value
                }
            })

            return returnVal
        }
        let act = row[param].filter(x => x.action_type === id)
        return act.length ? +act[0].value : 0
    }

    let get_action_val = (row, id) => {
        if (!row.action_values) {
            return 0
        }
        let act = row.action_values.filter(x => x.action_type.includes(id))
        return act.length ? +act[0].value : 0
    }

    let get_lead_spend = (row) => {
        let objective = row.objective
        
        return leadTypes.includes(objective) ? +row.spend : 0
    }

    let get_lead_items = (row, id) => {
        let objective = row.objective
        if (!row.unique_actions) {
            return 0
        }
        let act = row.unique_actions.filter(x => x.action_type === id)
        return leadTypes.includes(objective) && act.length ? +act[0].value : 0
    }
    
    let actions = {}
    perf.fbMetricsByDay = {}

    const resultTypeMap = {
        lead: {
            name: "Website Leads"
        },
        link_click: {
            name: "Link Clicks"
        },
        reach: {
            name: "Awareness"
        },
        "onsite_conversion.lead_grouped": {
            name: "On-Facebook Leads"
        },
        post_engagement: {
            name: "Post Engagement"
        },
        "offsite_conversion.fb_pixel_lead": {
            name: "Website Leads"
        },
        "offsite_conversion.custom": {
            name: "Custom Leads"
        }
    }

    const fbCampaignMap = {}

    fbMetrics.forEach(row => {
        let campaign = row[0].campaign_name
        let objective = row[0].objective

        if(fbCampaignMap[row[0].campaign_id] === undefined){
            fbCampaignMap[row[0].campaign_id] = campaign
        }

        if(perf.fbMetricsByDay[row[1]] === undefined){
            perf.fbMetricsByDay[row[1]] = {
                leads: 0,
                goals: 0,
                revenue: 0,
                spend: 0
            }
        }        

        if(actions[campaign] === undefined){
            switch (objective) {
                case 'CONVERSIONS':
                    actions[campaign] = {id: 'offsite_conversion.fb_pixel_lead', name: 'Conversions',
                        resultTypes: {
                            'offsite_conversion.fb_pixel_lead': 0
                        }    
                    }
                    break
                case 'LINK_CLICKS':
                    actions[campaign] = {
                        id: 'link_click', name: 'Traffic', 
                        resultTypes: {
                            'link_click': 0
                        }
                    }
                    break
                case 'LEAD_GENERATION':
                    actions[campaign] = {id: 'leadgen_grouped', name: 'FB Forms', resultTypes: {}}
                    break
                case 'POST_ENGAGEMENT':
                    actions[campaign] = {
                        id: 'link_click', name: 'Engagement', 
                        resultTypes: {
                            'link_click': 0
                        }
                    }
                break
                case 'OUTCOME_ENGAGEMENT':
                    actions[campaign] = {
                        id: 'link_click', name: 'Engagement', 
                        resultTypes: {
                            'link_click': 0
                        }
                    }
                    break
                case 'OUTCOME_LEADS':
                    actions[campaign] = {
                        id: ['offsite_conversion.custom','lead'], name: 'Leads',
                        resultTypes: {
                            'onsite_conversion.lead_grouped': 0, 
                            'lead': 0,
                            'offsite_conversion.custom': 0
                        }
                    }
                    break
                case 'OUTCOME_AWARENESS':
                    actions[campaign] = {
                        id: 'link_click', name: 'Awareness', 
                        resultTypes: {
                            'reach': 0
                        }
                    }
                    break
                default:
                    console.log('unknown objective: ', objective)
                    console.log('unknown objective: ', row)
                    actions[campaign] = {id: 'dummy', name: 'Unknown', resultTypes: {}}
                    break
            }
        }

        let goalVals = [
            get_action(row[0], actions[campaign].id) || get_action(row[0],actions[campaign].id, true),
            0,
            get_action(row[0], ['offsite_conversion.custom','lead'], true),
            get_action(row[0], 'offsite_conversion.fb_pixel_purchase', true)
        ]

        perf.fbMetricsByDay[row[1]].goals += (goalVals[0] || goalVals[2])
        perf.fbMetricsByDay[row[1]].leads += goalVals[2]
        perf.fbMetricsByDay[row[1]].revenue += (goalVals[3])
        perf.fbMetricsByDay[row[1]].spend += row[0].spend ? +row[0].spend : 0

        adMetricsByDay.push([row[0].spend ? +row[0].spend : 0, row[1]])

        Object.keys(actions[campaign].resultTypes).forEach(type => {
            let value = get_action(row[0], type, true) || get_action(row[0], type)
            actions[campaign].resultTypes[type] += value
        })
    })

    const financialTierField = site?.attr?.accounts?.fb?.financialTierField ?? "Investment"

    perf.fbFormLeadsByFinancialTier = sumByLastIndex(fbFormLeadMetrics.reduce((prev, lead) => {
        const foundFinLead = lead[0].field_data?.find(data => data.name === financialTierField)

        if(foundFinLead){
            prev.push(...foundFinLead.values.map(v => [1, v]))
        }

        return prev
    }, []))


    perf.fbFinQualByCampaign = sumByLastIndex(fbFormLeadMetrics.reduce((prev, lead) => {
        const foundFinLead = lead[0].field_data?.find(data => data.name === financialTierField)

        if(foundFinLead){
            if(foundFinLead.values[0] === "Yes"){
                prev.push([1, fbCampaignMap[lead[0].campaign_id]])
            }
        }

        return prev
    }, [])).reduce((prev, curr) => {
        prev[curr[0]] = curr[1][0]

        return prev
    }, {})

    perf.fbFormLeadMetrics = fbFormLeadMetrics
    
    perf.adsFBByCompaign = sumByLastIndex(fbMetrics.map(row => {
        return [
            get_action(row[0], 'link_click', true),
            row[0].impressions? +row[0].impressions: 0,
            get_action(row[0], 'link_click'),
            row[0].spend ? +row[0].spend : 0,
            0,
            get_action(row[0], actions[row[0].campaign_name].id, true) || get_action(row[0],actions[row[0].campaign_name].id),
            get_action(row[0], ['offsite_conversion.custom','lead'], true),
            get_lead_spend(row[0]),
            get_action_val(row[0], 'offsite_conversion.fb_pixel_purchase'),
            get_action(row[0], 'offsite_conversion.fb_pixel_purchase', true),
            get_action(row[0], 'offsite_conversion.fb_pixel_lead', true),
            get_action(row[0], 'offsite_conversion.fb_pixel_purchase', true),
            row[0].campaign_name
        ]
    })).map(item => {
        let resTypeName = "-"
        let resTypeValue = 0
        
        Object.keys(actions[item[0]].resultTypes).forEach(type => {
            let value = actions[item[0]].resultTypes[type]
            if(resTypeValue < value){
                resTypeValue = value
                resTypeName = resultTypeMap[type].name
            }
        })

        return [
            item[0],
            [
                ...item[1],
                resTypeValue,
                resTypeName
            ]
        ]        
    })
    
    perf.adsFBByCompaignTop = perf.adsFBByCompaign.sort((a, b) => +a[1][0]>+b[1][0] ? -1 : +a[1][0] === +b[1][0] ? 0 : 1).slice(0, 5) // top 5 clicks
    perf.adsFBByCompaignTotal = sumArrays(perf.adsFBByCompaign.map(el => el[1]))
    let convert = dv => ['iphone', 'android_smartphone'].includes(dv) ? 'mobile' : ['ipad', 'android_tablet'].includes(dv) ? 'tablet' : 'desktop'
    perf.adsFBByDevice = sumByLastIndex(fbMetrics.map(row => [
        get_action(row[0], 'link_click', true), 
        row[0].impressions ? +row[0].impressions : 0, 
        get_action(row[0], 'link_click'), 
        row[0].spend ? +row[0].spend : 0, 
        0, 
        get_action(row[0], actions[row[0].campaign_name].id, true) || get_action(row[0],actions[row[0].campaign_name].id),
        get_action(row[0], 'lead', true),
        get_lead_items(row[0], 'link_click'),
        get_action(row[0], 'offsite_conversion.fb_pixel_lead', true),
        convert(row[0].impression_device)
    ]))

    perf.adsFBByDeviceDetails = perf.adsFBByDevice.sort((a, b) => +a[1][3]>+b[1][3] ? -1 : +a[1][3] === +b[1][3] ? 0 : 1).map(src => ({
        id: src[0],
        sessions: src[1][0],
        goals: src[1][5] || src[1][8],
        leads: src[1][6] || src[1][8],
        gcr: parseFloat(formatAverage(100 * (src[1][5] || src[1][8] || 1), src[1][0])),
        leadsGcr: parseFloat(formatAverage(100 * (src[1][6] || src[1][8] || 1), src[1][7]))
    }))
    perf.adsFBByCompaign.forEach(el => el.push(actions[el[0]].name))
    perf.adsFBByCompaignDetails = perf.adsFBByCompaignTop.map(ad => {
        let campaign = ad[0]
        let recs = []
        trafReport.forEach(dayMetrics => {
            let fb = dayMetrics.fb, report = fb && fb.reports[0]
            if (!(report && report.data && report.data.rows)) {
              return
            }
            recs.push([dayMetrics.date,
              report.data.rows.filter(row => row.campaign_name === campaign)])
        })
        return {
          key: campaign,
          values: recs.map(row => [
            date_times[row[0]],
            row[1].length ?
              row[1].reduce((a, b) => a+(+get_action(b, 'link_click', true)), 0) :
              0
          ]),
        }
    })

    perf.adMetricsByDay = sumByLastIndex(adMetricsByDay)
    perf.gaAdMetricsByDay = sumByLastIndex(gaAdMetricsByDay)

    perf.leadTotalByCampaignTbl = adMetricsUnfettered.reduce((map, m, idx, arr) => {
        let sessions = parseInt(m[0])
        let goals = parseInt(m[2])

        let campaign = m[m.length - 1]
        let source = m[m.length - 2]

        if(map[source] === undefined){
            map[source] = {}
        }
        if(map[source][campaign] === undefined){
            map[source][campaign] = {
                campaign,
                goals: 0,
                sessions: 0,
                gcr: 0
            }
        }

        map[source][campaign].goals += goals
        map[source][campaign].sessions += sessions

        // if(leadsBySrcMed[campaign]){
        //     map[campaign].goalsAfterHours = leadsBySrcMed[campaign].valueAfterHours
        // }

        // if(idx === arr.length -1){
        //     Object.keys(map).forEach(key => {
        //         map[key].gcr = (map[key].goals / map[key].sessions * 100).toFixed(0)
        //     })
        // }

        return map
    }, {})

    perf.adsFBByCompaign.forEach(item => {
        let campaign = item[0]
        if(perf.leadTotalByCampaignTbl["facebook"] === undefined){
            perf.leadTotalByCampaignTbl["facebook"] = {}
        }
        if(perf.leadTotalByCampaignTbl["facebook"][campaign] === undefined){
            perf.leadTotalByCampaignTbl["facebook"][campaign] = {
                campaign,
                goals: 0,
                sessions: 0,
                gcr: 0
            }
        }

        perf.leadTotalByCampaignTbl["facebook"][campaign].goals += (item[1][6] || item[1][10])
        perf.leadTotalByCampaignTbl["facebook"][campaign].sessions += (item[1][0])
    })

    perf.trafReport = trafReport

    if(import.meta.env.MODE !== "production"){
        console.timeEnd("processResponse")
    }
    return perf
}
